import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MaskPipe } from 'ngx-mask';
import { HttpClient, HttpParams } from '@angular/common/http';
import { permission } from 'src/app/data/permissions';
import Utils, { BrValidators } from 'src/app/helpers/utils';
import { ApiService } from 'src/app/services/api/api.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { StorageService } from 'src/app/services/storage/storage.service';
import { ToastService } from 'src/app/services/toast/toast.service';

@Component({
  selector: 'app-dashboard-accounts',
  templateUrl: './dashboard-accounts.component.html',
  styleUrls: ['./dashboard-accounts.component.scss'],
})
export class DashboardAccountsComponent implements OnInit {
  roleForm = this.formBuilder.group({
    role: [null, [Validators.required]],
  });

  permissionObj: PermissionValues = {
    canFilter: false,
    canAdd: false,
  };

  accounts: Register[] = [];
  selectedAccount: Register | null = null;
  primaryRoleOptions: SelectItem[] = [];

  roleFilterOptions: SelectItem[] = [
    { label: 'Cotista - Pessoa Física', value: 'cotista-pf' },
    { label: 'Cotista - Pessoa Jurídica', value: 'cotista-pj' },
    { label: 'Cotista - Fundo de investimento', value: 'cotista-fundo' },
    { label: 'Cedente - Pessoa Física', value: 'cedente-pf' },
    { label: 'Cedente - Pessoa Jurídica', value: 'cedente-pj' },
    { label: 'Prestador - Pessoa Física', value: 'prestador-pf' },
    { label: 'Prestador - Pessoa Jurídica', value: 'prestador-pj' },
  ];

  // Valores para os cards de summary
  summaryStatistics = {
    pending: 0,
    in_progress: 0,
    homologated: 0,
    rejected: 0,
    active: 0,
    inactive: 0,
    total: 0,
  };
  loadingSummary = true;

  expandedRows = new Set<string>();
  showPaperStatusModal = false;
  paperStatusSubmitting = false;
  selectedPaperItem: Register | null = null;
  selectedPaperRole: any = null;
  showRegisterStatusModal = false;
  registerStatusSubmitting = false;
  selectedRegisterItem: Register | null = null;
  registerActivateAllPapers = false;
  registerActivatePaperSelectItems: SelectItem[] = [];

  accountsLoading: boolean = true;
  selectedApplicable: string = null;
  selectedNewUserApplicable: string = null;
  filteredRoleOptions: SelectItem[] = [];
  roleOptions: SelectItem[] = [];
  statusOptions: SelectItem[] = [
    { label: 'Em aprovação', value: 'em_aprovacao' },
    { label: 'Em edição', value: 'em_edicao' },
    { label: 'Homologado', value: 'aprovado' },
    { label: 'Rejeitado', value: 'rejeitado' },
  ];
  sendingRequest: boolean = false;
  warningModal: boolean = false;
  roles: Role[] = [];

  // Controle de requisições para evitar race conditions
  private requestCounter: number = 0;

  roleModal: boolean = false;
  count: number = 0;
  showFilterModal = false;
  sortButtonExpanded = false;
  showExportOptions = false;
  exporting = false;

  activeTab: 'all' | 'editing' | 'approval' | 'homologated' | 'rejected' =
    'all';

  // Armazenar filtros separados por aba
  tabFilters: {
    all: any;
    editing: any;
    approval: any;
    homologated: any;
    rejected: any;
  } = {
    all: null,
    editing: null,
    approval: null,
    homologated: null,
    rejected: null,
  };

  newUserModal: boolean = false;
  fundOptions: SelectItem[] = [];
  loadingFunds = true;
  isCnpjDocument = false;
  editingLoading: boolean = false;

  // Controle de validação de documento
  checkingDocument: boolean = false;
  documentExists: boolean | null = null;
  availablePapers: any[] = [];
  currentPapers: any[] = [];
  currentRole: any[] = [];
  userName: string = '';

  // Controle de colaborador
  isCollaborator: boolean = false;
  collaboratorInfo: any = null;
  collaboratorMessage: string = '';

  // Controle de verificação de documento (similar ao modal de convite)
  documentInviteError: string = null;
  showOtherFields = false;
  documentVerified = false;
  hasPendingApproval: boolean = false;
  pendingApprovalRole: string = '';
  hasInviteSent: boolean = false;
  inviteStatus: string = '';
  invitedData: any = null;
  hasRoleDraft: boolean = false;
  roleDraftInfo: any = null;
  approvedRoles: any[] = [];
  existingRegisterId: string | null = null; // Armazenar register_id quando documento já existe

  newUserForm = this.formBuilder.group({
    role: [null, [Validators.required]],
    interest_fund: [null, []],
    document: [null, Validators.required],
    full_name: [null, [Validators.required]],
    email: [null, []],
    agent: [null, []],
  });

  async toggleSortButton() {
    this.sortButtonExpanded = !this.sortButtonExpanded;
    this.accountsLoading = true;
    this.loadingSummary = true;
    await this.getData(1, undefined, true);
  }

  async refreshData() {
    this.accountsLoading = true;
    this.loadingSummary = true;
    await this.getData(1, undefined, true);
  }

  toggleRow(item: Register) {
    const key = String(item.id);
    if (this.expandedRows.has(key)) {
      this.expandedRows.delete(key);
      return;
    }
    this.expandedRows.add(key);
  }

  isRowExpanded(item: Register): boolean {
    return this.expandedRows.has(String(item.id));
  }

  getProfileValidityDate(item: Register): string {
    const data = this.getInvestorProfileData(item);
    if (!data || !data.expire_date) {
      return '-';
    }

    const expireDate =
      data.expire_date instanceof Date
        ? data.expire_date
        : new Date(data.expire_date);
    if (Number.isNaN(expireDate.getTime())) {
      return '-';
    }

    const day = String(expireDate.getDate()).padStart(2, '0');
    const month = String(expireDate.getMonth() + 1).padStart(2, '0');
    const year = expireDate.getFullYear();
    return `${day}/${month}/${year}`;
  }

  getPaperState(_item: Register): string {
    return 'Ativo';
  }

  isPaperActive(item: Register): boolean {
    return this.getPaperState(item) === 'Ativo';
  }

  /** Ativo/inativo do papel na linha expandida (`papers[].active` ou `role_controls[].state`). */
  isRoleActive(_item: Register, rc: any): boolean {
    if (typeof rc?.active === 'boolean') return rc.active;
    return (rc?.state ?? '').toString().toLowerCase() === 'active';
  }

  /** Retorna true se o papel for Representante (não permite ativar/inativar). */
  isRepresentativeRole(role: any): boolean {
    if (!role) return false;
    const applicable = (role.applicable || '').toString().toLowerCase();
    const slug = (role.slug || '').toString().toLowerCase();
    const name = (role.name || role.applicable_display || '').toString().toLowerCase();
    return (
      applicable === 'representative' ||
      slug.includes('representative') ||
      name.includes('representante')
    );
  }

  /** Linha expandida: mesmo critério que em Todos os cadastros. */
  isRepresentativeRoleControl(rc: any): boolean {
    if (!rc) return false;
    const role = rc.role || {};
    const applicable = (role.applicable || '').toString().toLowerCase();
    const slug = (role.slug || '').toString().toLowerCase();
    const name = (role.name || rc.role_name || '').toString().toLowerCase();
    return (
      applicable === 'representative' ||
      slug.includes('representative') ||
      name.includes('representante')
    );
  }

  getPaperActionTitle(item: Register | null, rc?: any): string {
    if (rc && this.isRepresentativeRoleControl(rc)) return '';
    const active =
      item && rc != null ? this.isRoleActive(item, rc) : false;
    return active ? 'Inativar Papel' : 'Ativar Papel';
  }

  getPaperActionMessage(item: Register | null, rc?: any): string {
    if (rc && this.isRepresentativeRoleControl(rc)) return '';
    const active =
      item && rc != null ? this.isRoleActive(item, rc) : false;
    return active
      ? 'Tem certeza que deseja inativar o papel'
      : 'Tem certeza que deseja ativar o papel';
  }

  getPaperActionTooltip(item: Register, rc?: any): string {
    if (rc && this.isRepresentativeRoleControl(rc)) return '';
    const active =
      rc != null ? this.isRoleActive(item, rc) : this.isPaperActive(item);
    return active ? 'Inativar papel' : 'Ativar papel';
  }

  /**
   * Linhas da tabela expandida: somente `papers` (sem fallback para role_controls).
   */
  getRoleControlsList(item: Register): any[] {
    const reg = item as any;
    const papers = Array.isArray(reg?.papers) ? reg.papers : [];

    if (papers.length === 0) {
      return [];
    }

    const profileValidity =
      reg?.investor_profile?.expire_register ??
      reg?.registration_expiration_date ??
      reg?.investor_profile?.validity ??
      null;
    const registerInvestorProfile =
      reg?.investor_profile?.profile_display ??
      reg?.investor_profile?.profile ??
      null;

    return papers.map((paper: any) => ({
      ...paper,
      state: paper?.active ? 'active' : 'inactive',
      created_at: paper?.created_at ?? reg?.created_at ?? null,
      profile_validity: paper?.profile_validity ?? profileValidity,
      register_investor_profile: registerInvestorProfile,
    }));
  }

  private normalizeSlug(value?: string): string {
    return (value || '').trim().toLowerCase();
  }

  getRoleControl(item: Register, role: any): any | null {
    const roleControls = (item as any)?.role_controls;
    if (!Array.isArray(roleControls) || roleControls.length === 0) {
      return null;
    }

    const roleId =
      role?.id !== undefined && role?.id !== null ? Number(role.id) : null;
    const roleSlug = this.normalizeSlug(role?.slug);

    const matched = roleControls.find((control: any) => {
      const controlRole = control?.role || {};
      const controlRoleId =
        controlRole?.id !== undefined && controlRole?.id !== null
          ? Number(controlRole.id)
          : null;
      const controlRoleSlug = this.normalizeSlug(controlRole?.slug);

      if (
        roleId !== null &&
        controlRoleId !== null &&
        roleId === controlRoleId
      ) {
        return true;
      }

      if (roleSlug && controlRoleSlug && roleSlug === controlRoleSlug) {
        return true;
      }

      return false;
    });

    return matched || null;
  }

  private mapRoleControlStatus(raw?: string): string {
    const normalized = (raw || '').toString().trim().toLowerCase();
    if (/editing|created|em edição|em edicao/.test(normalized)) return 'Em edição';
    if (/pending|in approval|em aprovação|em aprovacao/.test(normalized)) {
      return 'Em aprovação';
    }
    if (/approved|homologated|homologado|aprovado/.test(normalized)) {
      return 'Homologado';
    }
    if (/rejected|rejeitado/.test(normalized)) return 'Rejeitado';
    return raw ? String(raw) : '—';
  }

  getRoleControlStatusDisplay(rc: any): string {
    const raw = rc?.status_display ?? rc?.status;
    return raw ? this.mapRoleControlStatus(String(raw)) : '—';
  }

  getRoleControlStatusClass(rc: any): string {
    const status = this.getRoleControlStatusDisplay(rc).toLowerCase();
    if (/homologado/.test(status)) return 'status-badge status-badge-homologated';
    if (/rejeitado/.test(status)) return 'status-badge status-badge-rejected';
    if (/em aprovação/.test(status)) return 'status-badge status-badge-approval';
    return 'status-badge status-badge-editing';
  }

  getRoleControlProfile(rc: any): string {
    const role = rc?.role ?? {};
    const applicable = (role?.applicable || '').toString().toLowerCase();
    if (applicable === 'shareholder') {
      const shareholderProfile = rc?.register_investor_profile;
      return shareholderProfile ? String(shareholderProfile).trim() : 'Não aplicável';
    }
    const value = rc?.investor_profile ?? rc?.profile ?? '';
    return (value && String(value).trim()) ? String(value).trim() : 'Não aplicável';
  }

  getRoleControlProfileBadgeStyle(rc: any): { [key: string]: string } {
    const label = this.getRoleControlProfile(rc);
    const normalized = (label || '').toLowerCase().trim();
    let config: {
      badgeBackgroundColor: string;
      badgeTextColor: string;
    } | null = null;
    if (/conservador/.test(normalized)) config = this.getInvestorProfileConfig(1);
    else if (/moderado/.test(normalized))
      config = this.getInvestorProfileConfig(2);
    else if (/agressivo/.test(normalized))
      config = this.getInvestorProfileConfig(3);
    else config = this.getNotDeclaredConfig();
    if (!config) return {};
    return {
      'background-color': config.badgeBackgroundColor,
      color: config.badgeTextColor,
    };
  }

  private formatPaperDateTime(raw: string): string {
    const date = new Date(raw);
    if (Number.isNaN(date.getTime())) return '—';
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${day}/${month}/${year} às ${hours}:${minutes}`;
  }

  private formatPaperDateOnly(raw: string): string {
    const date = new Date(raw);
    if (Number.isNaN(date.getTime())) return '—';
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  getRoleControlCreatedAt(rc: any): string {
    const raw = rc?.created_at;
    if (!raw) return '—';
    return this.formatPaperDateTime(String(raw));
  }

  getRoleControlValidity(rc: any): string {
    const raw = rc?.profile_validity;
    if (!raw) return '—';
    return this.formatPaperDateOnly(String(raw));
  }

  /** Verifica se um role_control está ativo (state === 'active' vindo do EP, ou status/estado legado). */
  private isRoleControlActive(control: any): boolean {
    if (!control) return false;
    const state = (control.state || '').toString().toLowerCase();
    if (state === 'active') return true;
    const status = (control.status || '').toString().toLowerCase();
    if (status === 'active') return true;
    const estado = (control.estado || '').toString();
    return estado === 'Ativo';
  }

  /**
   * Estado na coluna principal: usa status do backend se existir; senão deriva de role_controls quando houver (vários papéis);
   * se não houver role_controls (registro com apenas 1 papel), considera "Ativo".
   */
  getEstadoAtivoInativo(item: Register): string {
    const reg = item as any;
    if (typeof reg?.active === 'boolean') {
      return reg.active ? 'Ativo' : 'Inativo';
    }
    const isActiveBool = reg?.is_active;
    if (typeof isActiveBool === 'boolean') {
      return isActiveBool ? 'Ativo' : 'Inativo';
    }
    const value = reg?.registration_state ?? reg?.role_state ?? reg?.estado ?? reg?.state;
    if (value !== undefined && value !== null && value !== '') {
      const s = Array.isArray(value) ? value[0] : value;
      const str = String(s).toLowerCase();
      return str === 'active' || str === 'ativo' || str === 'activo' ? 'Ativo' : 'Inativo';
    }
    const roleControls = reg?.role_controls;
    if (Array.isArray(roleControls) && roleControls.length > 0) {
      const allActive = roleControls.every((c: any) => this.isRoleControlActive(c));
      return allActive ? 'Ativo' : 'Inativo';
    }
    // Registro com apenas 1 papel (sem role_controls) → Ativo
    return 'Ativo';
  }

  /** Classe do badge da coluna Estado (linha principal). */
  getEstadoBadgeClass(item: Register): string {
    return this.getEstadoAtivoInativo(item) === 'Ativo'
      ? 'status-badge status-badge-homologated' // verdinho
      : 'status-badge status-badge-rejected'; // vermelhinho
  }

  getRoleControlEstado(rc: any): string {
    if (typeof rc?.active === 'boolean') {
      return rc.active ? 'Ativo' : 'Inativo';
    }
    const state = (rc?.state ?? rc?.estado ?? '').toString().trim().toLowerCase();
    if (!state) return '—';
    return state === 'active' || state === 'ativo' ? 'Ativo' : 'Inativo';
  }

  getRoleControlEstadoClass(rc: any): string {
    return this.getRoleControlEstado(rc) === 'Ativo'
      ? 'status-badge status-badge-homologated'
      : 'status-badge status-badge-rejected';
  }

  getRoleLabelForModal(rc: any): string {
    return this.getRoleControlPapelName(rc);
  }

  openPaperStatusModal(item: Register, rc: any) {
    this.selectedPaperItem = item;
    this.selectedPaperRole = rc;
    this.showPaperStatusModal = true;
  }

  onPaperActionClick(event: Event, item: Register, rc: any) {
    event.preventDefault();
    event.stopPropagation();
    this.openPaperStatusModal(item, rc);
  }

  closePaperStatusModal() {
    this.showPaperStatusModal = false;
    this.selectedPaperItem = null;
    this.selectedPaperRole = null;
  }

  async confirmPaperStatusChange() {
    if (!this.selectedPaperItem || !this.selectedPaperRole) {
      return;
    }

    const rc = this.selectedPaperRole;
    const paperId = rc?.id != null ? String(rc.id).trim() : '';

    if (!paperId) {
      this.toast.show(
        'error',
        'Erro',
        'Dados insuficientes para alterar o status do papel.',
      );
      return;
    }

    const currentlyActive = this.isRoleActive(this.selectedPaperItem, rc);
    const isInactivating = currentlyActive;
    const active = !isInactivating;

    this.paperStatusSubmitting = true;
    try {
      await this.api.patch({
        route: `api/v2/registration/registration-papers/${paperId}/`,
        token: true,
        body: {
          active,
        },
      });
      this.toast.show(
        'info',
        'Sucesso',
        isInactivating
          ? 'Papel inativado com sucesso.'
          : 'Papel ativado com sucesso.',
      );
      this.closePaperStatusModal();
      this.requestCounter++;
      const currentRequestId = this.requestCounter;
      await this.getData(1, currentRequestId, true);
    } catch (error) {
      console.error(error);
      this.toast.show(
        'error',
        'Erro',
        'Não foi possível alterar o status do papel. Tente novamente.',
      );
    } finally {
      this.paperStatusSubmitting = false;
      this.accountsLoading = false;
      this.loadingSummary = false;
    }
  }

  /** Rótulo na linha expandida / modais; inclui regra Cotista FI (nome/slug). */
  getRoleControlPapelName(paperOrRole: any): string {
    const role = paperOrRole?.role ?? paperOrRole ?? {};
    const applicable = (role?.applicable || '').toString().toLowerCase();
    const name = (role?.name || paperOrRole?.role_name || '').toString();
    const slug = (role?.slug || '').toString().toUpperCase();
    if (
      applicable === 'shareholder' &&
      (name.toUpperCase().includes('FI') || slug.includes('FI'))
    ) {
      return 'Cotista Fundo de Investimento';
    }
    return role?.applicable_display ?? role?.name ?? paperOrRole?.role_name ?? '—';
  }

  getRegisterPapersRaw(item: Register | null): any[] {
    if (!item) return [];
    const papers = (item as any)?.papers;
    return Array.isArray(papers) ? papers : [];
  }

  getRegisterPapersForActivation(
    item: Register | null,
  ): { id: string; label: string }[] {
    return this.getRegisterPapersRaw(item)
      .map((p: any) => ({
        id: p?.id != null ? String(p.id).trim() : '',
        label: this.getRoleControlPapelName(p),
      }))
      .filter((x) => x.id);
  }

  isRegisterActive(item: Register | null): boolean {
    if (!item) return false;
    const a = (item as any)?.active;
    if (typeof a === 'boolean') return a;
    return this.getEstadoAtivoInativo(item) === 'Ativo';
  }

  getRegisterActionTooltip(item: Register): string {
    return this.isRegisterActive(item)
      ? 'Inativar cadastro'
      : 'Ativar cadastro';
  }

  getRegisterActionTitle(item: Register | null): string {
    return this.isRegisterActive(item)
      ? 'Inativar Cadastro'
      : 'Ativar Cadastro';
  }

  getRegisterActionMessage(item: Register | null): string {
    return this.isRegisterActive(item)
      ? 'Tem certeza que deseja inativar o cadastro'
      : 'Tem certeza que deseja ativar o cadastro';
  }

  isRegisterActivationSinglePaper(): boolean {
    const item = this.selectedRegisterItem;
    if (!item || this.isRegisterActive(item)) return false;
    return this.getRegisterPapersForActivation(item).length === 1;
  }

  getSingleRegisterActivationPaperLabel(): string {
    const item = this.selectedRegisterItem;
    if (!item) return '—';
    const papers = this.getRegisterPapersForActivation(item);
    return papers[0]?.label ?? '—';
  }

  isRegisterActivationMultiPaper(): boolean {
    const item = this.selectedRegisterItem;
    if (!item || this.isRegisterActive(item)) return false;
    return this.getRegisterPapersForActivation(item).length > 1;
  }

  isRegisterActivationConfirmDisabled(): boolean {
    if (!this.selectedRegisterItem || this.isRegisterActive(this.selectedRegisterItem)) {
      return false;
    }
    if (!this.isRegisterActivationMultiPaper()) {
      return false;
    }
    if (this.registerActivateAllPapers) {
      return false;
    }
    const raw = this.registerActivatePapersForm.get('paperIds')?.value;
    const ids = Array.isArray(raw) ? raw : [];
    return ids.length === 0;
  }

  onRegisterActivateAllToggle(): void {
    if (this.registerActivateAllPapers) {
      this.registerActivatePapersForm.patchValue({ paperIds: [] });
    }
  }

  onRegisterActionClick(event: Event, item: Register) {
    event.preventDefault();
    event.stopPropagation();
    this.openRegisterStatusModal(item);
  }

  openRegisterStatusModal(item: Register) {
    this.selectedRegisterItem = item;
    this.registerActivateAllPapers = false;
    this.registerActivatePaperSelectItems =
      this.getRegisterPapersForActivation(item).map((p) => ({
        label: p.label,
        value: p.id,
      }));
    this.registerActivatePapersForm.patchValue({ paperIds: [] });
    this.showRegisterStatusModal = true;
  }

  closeRegisterStatusModal() {
    this.showRegisterStatusModal = false;
    this.selectedRegisterItem = null;
    this.registerActivateAllPapers = false;
    this.registerActivatePaperSelectItems = [];
    this.registerActivatePapersForm.patchValue({ paperIds: [] });
  }

  async confirmRegisterStatusChange() {
    const item = this.selectedRegisterItem;
    if (!item?.id) return;

    const registerUuid = String(item.id).trim();
    const isInactivating = this.isRegisterActive(item);
    const active = !isInactivating;

    let paperIdsToActivate: string[] = [];
    if (!isInactivating) {
      const papers = this.getRegisterPapersRaw(item);
      if (papers.length === 0) {
        this.toast.show(
          'error',
          'Erro',
          'Nenhum papel encontrado para este cadastro.',
        );
        return;
      }
      if (papers.length === 1) {
        const id = papers[0]?.id != null ? String(papers[0].id).trim() : '';
        if (!id) {
          this.toast.show(
            'error',
            'Erro',
            'Dados insuficientes para ativar o cadastro.',
          );
          return;
        }
        paperIdsToActivate = [id];
      } else {
        if (this.registerActivateAllPapers) {
          paperIdsToActivate = papers
            .map((p: any) => (p?.id != null ? String(p.id).trim() : ''))
            .filter(Boolean);
        } else {
          const raw = this.registerActivatePapersForm.get('paperIds')?.value;
          const ids = Array.isArray(raw) ? raw : [];
          paperIdsToActivate = ids.map((id) => String(id).trim()).filter(Boolean);
        }
        if (paperIdsToActivate.length === 0) {
          return;
        }
      }
    }

    this.closeRegisterStatusModal();
    this.registerStatusSubmitting = true;

    try {
      if (isInactivating) {
        await this.api.patch({
          route: 'api/v3/registration/registers/',
          token: true,
          body: {
            register_uuid: registerUuid,
            active,
          },
        });
        this.toast.show('info', 'Sucesso', 'Cadastro inativado com sucesso.');
      } else {
        const paperResults = await Promise.all(
          paperIdsToActivate.map((paperId) =>
            this.api
              .patch({
                route: `api/v2/registration/registration-papers/${paperId}/`,
                token: true,
                body: { active: true },
              })
              .then(() => ({ ok: true as const }))
              .catch(() => ({ ok: false as const })),
          ),
        );
        const paperFailures = paperResults.filter((r) => !r.ok).length;
        if (paperFailures > 0) {
          this.toast.show(
            'warning',
            'Atenção',
            'Não foi possível concluir todas as ações.',
          );
        }
        try {
          await this.api.patch({
            route: 'api/v3/registration/registers/',
            token: true,
            body: {
              register_uuid: registerUuid,
              active: true,
            },
          });
          if (paperFailures === 0) {
            this.toast.show(
              'info',
              'Sucesso',
              'Cadastro ativado com sucesso.',
            );
          }
        } catch {
          this.toast.show(
            'error',
            'Erro',
            'Não foi possível alterar o status do cadastro. Tente novamente.',
          );
        }
      }

      await this.getData(1, undefined, true);
    } catch {
      if (isInactivating) {
        this.toast.show(
          'error',
          'Erro',
          'Não foi possível alterar o status do cadastro. Tente novamente.',
        );
      }
    } finally {
      this.registerStatusSubmitting = false;
      this.accountsLoading = false;
      this.loadingSummary = false;
    }
  }

  getSortButtonLabel() {
    return this.sortButtonExpanded ? 'Mais antigos' : 'Mais recentes';
  }

  toggleFilterModal() {
    this.showFilterModal = !this.showFilterModal;

    if (this.showFilterModal) {
      // Carregar os filtros da aba atual no formulário
      const savedFilters = this.tabFilters[this.activeTab];

      if (savedFilters) {
        // Preparar o documento formatado
        let documentFormatted = null;
        if (savedFilters.document) {
          const docLength = savedFilters.document.length;
          if (docLength === 11) {
            documentFormatted = this.maskPipe.transform(
              savedFilters.document,
              '000.000.000-00',
            );
          } else if (docLength === 14) {
            documentFormatted = this.maskPipe.transform(
              savedFilters.document,
              '00.000.000/0000-00',
            );
          } else {
            // Se não tem tamanho válido, usar o valor original
            documentFormatted = savedFilters.document;
          }
        }

        const { registration_state, role_state, ...rest } = savedFilters;
        const estadoCadastroTodos = !(
          Array.isArray(registration_state) && registration_state.length > 0
        );
        const estadoCadastroAtivo =
          Array.isArray(registration_state) &&
          registration_state.includes('active');
        const estadoCadastroInativo =
          Array.isArray(registration_state) &&
          registration_state.includes('inactive');
        const estadoTodos = !(
          Array.isArray(role_state) && role_state.length > 0
        );
        const estadoAtivo =
          Array.isArray(role_state) && role_state.includes('active');
        const estadoInativo =
          Array.isArray(role_state) && role_state.includes('inactive');

        this.filterForm.patchValue({
          ...rest,
          document: documentFormatted,
          estadoCadastroTodos,
          estadoCadastroAtivo,
          estadoCadastroInativo,
          estadoTodos,
          estadoAtivo,
          estadoInativo,
        });

        this.hasFilters = true;
        // Gera as tags dos filtros salvos
        this.generateFilterTags(this.filterForm.value);
      } else {
        // Se não há filtros salvos, garantir que o formulário está limpo
        this.hasFilters = false;
        this.appliedFilters = [];
      }
    }
  }

  /** Garante seleção única em Estado do cadastro: ao marcar um, desmarca os outros. */
  onEstadoCadastroChange(opcao: 'todos' | 'ativo' | 'inativo') {
    this.filterForm.patchValue(
      {
        estadoCadastroTodos: opcao === 'todos',
        estadoCadastroAtivo: opcao === 'ativo',
        estadoCadastroInativo: opcao === 'inativo',
      },
      { emitEvent: false },
    );
  }

  /** Garante seleção única em Estado dos papéis: ao marcar um, desmarca os outros. */
  onEstadoPapeisChange(opcao: 'todos' | 'ativo' | 'inativo') {
    this.filterForm.patchValue(
      {
        estadoTodos: opcao === 'todos',
        estadoAtivo: opcao === 'ativo',
        estadoInativo: opcao === 'inativo',
      },
      { emitEvent: false },
    );
  }

  dataFilters: any = null;
  offset: number = 0;
  showing_to: number = 0;

  /**
   * Padrão de Filtros:
   * - hasFilters só deve ser true APÓS aplicar os filtros (método filterData())
   * - NÃO atualizar hasFilters no valueChanges do filterForm
   * - hasFilters deve ser atualizado apenas quando:
   *   1. filterData() executar com sucesso (após a requisição)
   *   2. resetForm() for chamado (define como false)
   *   3. toggleFilterModal() quando há filtros salvos no storage
   *
   * Isso garante que o botão "Limpar filtros" só apareça após os filtros serem realmente aplicados,
   * não apenas quando o usuário está digitando no formulário.
   */
  hasFilters = false;
  appliedFilters: Array<{ label: string; value: string }> = [];

  // Modal properties
  showEditWarningModal = false;

  today = Utils.todayString();

  filterForm = this.formBuilder.group({
    name: [null],
    document: [null, [Utils.validateCpfCnpj]],
    status: [null],
    role: [null],
    agent: [null],
    created_from: [
      null,
      [
        Utils.validateWhenNotEmpty(Utils.validateMaxMinToday),
        Utils.validateWhenNotEmpty(Utils.validateMinDate),
      ],
    ],
    created_to: [
      null,
      [
        Utils.validateWhenNotEmpty((control: FormControl) =>
          Utils.validateMaxMinToday(control, false),
        ),
        Utils.validateWhenNotEmpty(Utils.validateMaxDate),
      ],
    ],
    updated_from: [
      null,
      [
        (control: FormControl) => {
          if (!control.value) {
            return null;
          }

          if (Utils.validateDateValid(control)) {
            this.errrorMessageObj.updated_from = 'Data inválida';
            return { date: true };
          }

          control.parent?.controls?.['updated_to'].setValidators([
            Validators.required,
            (control: FormControl) => {
              if (Utils.validateDateValid(control)) {
                this.errrorMessageObj.updated_to = 'Data inválida';
                return { date: true };
              }

              if (Utils.validateMaxMinToday(control)) {
                this.errrorMessageObj.updated_to =
                  'A data não pode ser maior que hoje';
                return { max: true };
              }

              const toValue = control.value.split('/').reverse().join('-');
              const fromValue = control.parent.controls?.['updated_from'].value
                ? control.parent.controls?.['updated_from'].value
                    .split('/')
                    .reverse()
                    .join('-')
                : null;

              if (fromValue) {
                let fromDate = new Date(fromValue);
                const toDate = new Date(toValue);

                if (fromDate > toDate) {
                  this.errrorMessageObj.updated_to =
                    'A data final não pode ser menor que a data inicial';
                  return { min: true };
                }
              }

              return null;
            },
          ]);

          control.parent?.controls?.['updated_to'].updateValueAndValidity();

          if (Utils.validateMinDate(control)) {
            this.errrorMessageObj.updated_from = 'Data mínima inválida';
            return { min: true };
          }

          if (Utils.validateMaxMinToday(control)) {
            this.errrorMessageObj.updated_from =
              'A data não pode ser maior que hoje';
            return { max: true };
          }

          return null;
        },
      ],
    ],
    updated_to: [
      null,
      [
        (control: FormControl) => {
          if (!control.value) {
            return null;
          }

          if (Utils.validateDateValid(control)) {
            this.errrorMessageObj.updated_to = 'Data inválida';
            return { date: true };
          }

          if (Utils.validateMaxMinToday(control)) {
            this.errrorMessageObj.updated_to =
              'A data não pode ser maior que hoje';
            return { max: true };
          }

          const toValue = control.value.split('/').reverse().join('-');
          const fromValue = control.parent.controls?.['updated_from'].value
            ? control.parent.controls?.['updated_from'].value
                .split('/')
                .reverse()
                .join('-')
            : null;

          if (fromValue) {
            let fromDate = new Date(fromValue);
            const toDate = new Date(toValue);

            if (fromDate > toDate) {
              this.errrorMessageObj.updated_to =
                'A data final não pode ser menor que a data inicial';
              return { min: true };
            }
          }

          return null;
        },
      ],
    ],
    expiry_from: [
      null,
      [
        Utils.validateWhenNotEmpty(Utils.validateMaxMinToday),
        Utils.validateWhenNotEmpty(Utils.validateMinDate),
      ],
    ],
    expiry_to: [
      null,
      [
        Utils.validateWhenNotEmpty((control: FormControl) =>
          Utils.validateMaxMinToday(control, false),
        ),
        Utils.validateWhenNotEmpty(Utils.validateMaxDate),
      ],
    ],
    profileConservador: [false],
    profileModerado: [false],
    profileAgressivo: [false],
    profileNaoAplicavel: [false],
    statusHomologado: [false],
    statusEmAprovacao: [false],
    statusEmEdicao: [false],
    statusRejeitado: [false],
    estadoCadastroTodos: [true],
    estadoCadastroAtivo: [false],
    estadoCadastroInativo: [false],
    estadoTodos: [true],
    estadoAtivo: [false],
    estadoInativo: [false],
  });

  registerActivatePapersForm = this.formBuilder.group({
    paperIds: [[] as string[]],
  });

  errrorMessageObj: any = {
    created_from: '',
    created_to: '',
    updated_from: '',
    updated_to: '',
    expiry_from: '',
    expiry_to: '',
  };

  constructor(
    private toast: ToastService,
    private api: ApiService,
    private authService: AuthService,
    private router: Router,
    private formBuilder: FormBuilder,
    private storageService: StorageService,
    private maskPipe: MaskPipe,
    private http: HttpClient,
  ) {}

  get hasAnyFilterValue(): boolean {
    const values = this.filterForm.value;
    return Object.values(values).some((value: any) => {
      if (value === null || value === '') {
        return false;
      }
      if (Array.isArray(value) && value.length === 0) {
        return false;
      }
      return true;
    });
  }

  get canApplyFilters(): boolean {
    // Verifica se há algum filtro preenchido
    if (!this.hasAnyFilterValue) {
      return false;
    }

    // Verifica se o documento é válido (quando preenchido)
    const documentControl = this.filterForm.controls.document;
    if (documentControl.value && documentControl.invalid) {
      return false;
    }

    return true;
  }

  get filterButtonLabel(): string {
    return this.hasFilters ? 'Editar filtros' : 'Filtrar listagem';
  }

  toggleExportOptions() {
    this.showExportOptions = !this.showExportOptions;
  }

  buildExportFilters(): Record<string, any> {
    const filters = this.buildFilters();
    return {
      ...filters,
      tab: 'all',
      return_distinct: true,
      order_by: this.sortButtonExpanded ? '-created_at' : 'created_at',
    };
  }

  downloadTable(format: 'csv' | 'xlsx' | 'pdf') {
    this.toggleExportOptions();
    this.exporting = true;

    const filters = this.buildExportFilters();
    const headers = this.api.getHeaders(true, true);

    const params = new HttpParams({
      fromObject: { ...filters, export: format },
    });

    this.http
      .get(`${this.api.url}/api/v3/registration/my-registers/export/`, {
        headers: headers,
        params: params,
        responseType: 'blob',
        observe: 'response',
      })
      .subscribe(
        (response: any) => {
          try {
            const blob = new Blob([response.body], {
              type:
                format === 'pdf'
                  ? 'application/pdf'
                  : format === 'csv'
                    ? 'text/csv'
                    : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;

            const contentDisposition = response.headers.get(
              'content-disposition',
            );
            let fileName = `meus_cadastros.${format}`;

            if (contentDisposition) {
              const fileNameMatch =
                contentDisposition.match(/filename="?(.+)"?/);
              if (fileNameMatch && fileNameMatch.length === 2) {
                fileName = fileNameMatch[1];
              }
            }

            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

            this.toast.show(
              'info',
              'Sucesso !',
              'Relatório gerado com sucesso!',
              null,
            );
          } catch (error) {
            console.error('Erro ao baixar exportação:', error);
            this.toast.show(
              'error',
              'Erro',
              'Falha ao baixar o arquivo.',
              null,
            );
          } finally {
            this.exporting = false;
          }
        },
        (error) => {
          console.error(error);
          this.toast.show('error', 'Erro', 'Erro ao baixar o arquivo.', null);
          this.exporting = false;
        },
      );
  }

  ngOnInit(): void {
    this.authService.canViewPage(['de_can_view_my_registers']);
    this.setPermissions();
    // Ativar ambos os loadings no início
    this.accountsLoading = true;
    this.loadingSummary = true;
    // Chamar ambos juntos para que os skeletons fiquem visíveis até ambos terminarem
    this.getData(1, undefined, true).finally(() => {
      this.accountsLoading = false;
      this.loadingSummary = false;
    });
    this.setAgents();
    this.getRoles();
    this.getFunds();

    this.filterForm.controls.role.valueChanges.subscribe((value) => {
      const selectedRole = this.roles.find((item) => item.id === Number(value));

      this.selectedApplicable = selectedRole ? selectedRole.applicable : null;

      if (this.selectedApplicable !== 'provider') {
        this.filterForm.controls.agent.setValue(null);

        this.filterForm.controls.agent.updateValueAndValidity();
      }
    });

    this.filterForm.get('created_from')?.valueChanges.subscribe(() => {
      this.filterForm.get('created_to')?.updateValueAndValidity();
    });
    this.filterForm.get('expiry_from')?.valueChanges.subscribe(() => {
      this.filterForm.get('expiry_to')?.updateValueAndValidity();
    });

    this.newUserForm.controls.role.valueChanges.subscribe((value) => {
      const selectedRole = this.roles.find((item) => item.id === Number(value));

      if (selectedRole) {
        this.isCnpjDocument = selectedRole.slug.includes('PJ');

        // Resetar estado do documento (mas não o valor do campo)
        this.documentExists = null;
        this.availablePapers = [];
        this.currentPapers = [];
        this.currentRole = [];
        this.userName = '';
        this.checkingDocument = false;
        this.isCollaborator = false;
        this.collaboratorInfo = null;
        this.collaboratorMessage = '';

        this.selectedApplicable = selectedRole
          ? selectedRole.applicable
          : 'assignor';

        this.selectedNewUserApplicable = selectedRole
          ? selectedRole.applicable
          : 'assignor';

        // Configurar validação do agente para prestador de serviço
        if (this.selectedApplicable === 'provider') {
          this.newUserForm.controls.agent.setValidators([Validators.required]);
        } else {
          this.newUserForm.controls.agent.setValidators([]);
        }

        // Configurar validação do fundo de interesse para cedente e cotista
        if (
          this.selectedApplicable === 'assignor' ||
          this.selectedApplicable === 'shareholder'
        ) {
          this.newUserForm.controls.interest_fund.setValidators([
            Validators.required,
          ]);
        } else {
          this.newUserForm.controls.interest_fund.setValidators([]);
        }

        this.newUserForm.controls.agent.setValue(null);
        this.newUserForm.controls.interest_fund.setValue(null);

        this.newUserForm.controls.agent.updateValueAndValidity();
        this.newUserForm.controls.interest_fund.updateValueAndValidity();
      }
    });

    // Validação de documento - resetar estado ao mudar documento
    this.newUserForm.controls.document.valueChanges.subscribe((value) => {
      const documentClean = value ? value.replace(/[^\d]+/g, '') : '';

      // Resetar estado ao mudar documento
      this.documentExists = null;
      this.availablePapers = [];
      this.currentPapers = [];
      this.currentRole = [];
      this.userName = '';
      this.checkingDocument = false;
      this.isCollaborator = false;
      this.collaboratorInfo = null;
      this.collaboratorMessage = '';
      this.hasPendingApproval = false;
      this.pendingApprovalRole = '';
      this.hasInviteSent = false;
      this.inviteStatus = '';
      this.invitedData = null;
      this.hasRoleDraft = false;
      this.roleDraftInfo = null;
      this.approvedRoles = [];
      this.documentVerified = false;
      this.showOtherFields = false;
      this.documentInviteError = null;

      // Resetar opções de papéis se documento foi limpo
      if (!documentClean || documentClean.length === 0) {
        this.updatePrimaryRoleOptions();
      }

      // Limpar erros anteriores
      this.newUserForm.controls.document.setErrors(null);

      // Limpar campos quando documento mudar
      this.newUserForm.controls.full_name.setValue(null, { emitEvent: false });
      this.newUserForm.controls.email.setValue(null, { emitEvent: false });
    });
  }

  async getRoles() {
    const res = await this.api.get<ApiResponse<Role[]>>({
      route: 'role/',
    });

    const { data } = res;

    this.roles = data;

    const userRoles = data
      .filter(
        (_item) => _item.is_visible && !_item.slug.includes('REPRESENTATIVE'),
      )
      .sort((a, b) => {
        if (a.applicable_display < b.applicable_display) {
          return -1;
        }
        if (a.applicable_display > b.applicable_display) {
          return 1;
        }
        return 0;
      })
      .map((item) => {
        return {
          label: `${item.applicable_display} - ${item.name}`,
          value: String(item.id),
          extra: item.slug,
        };
      });

    this.primaryRoleOptions = userRoles;
  }

  updatePrimaryRoleOptions(documentClean?: string) {
    // Se não tiver documento, usar todos os papéis
    if (!documentClean) {
      const userRoles = this.roles
        .filter(
          (_item) => _item.is_visible && !_item.slug.includes('REPRESENTATIVE'),
        )
        .sort((a, b) => {
          if (a.applicable_display < b.applicable_display) {
            return -1;
          }
          if (a.applicable_display > b.applicable_display) {
            return 1;
          }
          return 0;
        })
        .map((item) => {
          return {
            label: `${item.applicable_display} - ${item.name}`,
            value: String(item.id),
            extra: item.slug,
          };
        });
      this.primaryRoleOptions = userRoles;
      return;
    }

    // Determinar tipo do documento (PF = 11 dígitos, PJ = 14 dígitos)
    const isPF = documentClean.length === 11;
    const isPJ = documentClean.length === 14;

    // Filtrar papéis compatíveis com o tipo do documento
    let filteredRoles = this.roles.filter((_item) => {
      if (!_item.is_visible || _item.slug.includes('REPRESENTATIVE')) {
        return false;
      }

      // Filtrar por tipo: PF ou PJ baseado no slug
      const slugUpper = _item.slug.toUpperCase();
      if (isPF && !slugUpper.includes('PF')) {
        return false;
      }
      if (isPJ && !slugUpper.includes('PJ')) {
        return false;
      }

      return true;
    });

    // Filtrar papéis que o usuário já possui (approvedRoles)
    if (this.approvedRoles && this.approvedRoles.length > 0) {
      const approvedRoleIds = this.approvedRoles.map((role) => String(role.id));
      const approvedApplicables = this.approvedRoles.map(
        (role) => role.applicable,
      );

      filteredRoles = filteredRoles.filter((role) => {
        const roleId = String(role.id);
        // Não mostrar se o ID já está aprovado ou se o applicable já está aprovado
        return (
          !approvedRoleIds.includes(roleId) &&
          !approvedApplicables.includes(role.applicable)
        );
      });
    }

    // Ordenar e mapear para SelectItem
    const userRoles = filteredRoles
      .sort((a, b) => {
        if (a.applicable_display < b.applicable_display) {
          return -1;
        }
        if (a.applicable_display > b.applicable_display) {
          return 1;
        }
        return 0;
      })
      .map((item) => {
        return {
          label: `${item.applicable_display} - ${item.name}`,
          value: String(item.id),
          extra: item.slug,
        };
      });

    this.primaryRoleOptions = userRoles;
  }

  async setAgents() {
    try {
      const res = await this.api.get({
        route: 'api/registration/agent/',
        token: true,
      });

      this.roleOptions = res.map((item: any) => {
        return {
          label: item.name,
          value: item.id,
        };
      });
    } catch (error) {
      console.warn(error);
      this.toast.show('error', 'Erro', 'Ocorreu um erro ao carregar os dados.');
    }
  }

  async addAgentRole() {
    try {
      const payload = [
        ...this.selectedAccount.agent.map((item) => item.id),
        ...this.roleForm.controls.role.value,
      ];

      await this.api.patch<ApiResponse<Register>>({
        route: `api/registration/register/${this.selectedAccount.id}/`,
        token: true,
        body: {
          agent: payload,
        },
      });

      this.toast.show('info', 'Sucesso!', 'Papel adicionado com sucesso');

      this.closeModal();
      this.getData(1, undefined, true);
    } catch (error) {
      this.toast.show('error', 'Erro!', 'Erro ao adicionar papel');
    }
  }

  closeModal() {
    this.roleModal = false;
    this.selectedAccount = null;
    this.roleForm.reset();
  }

  getDisplayDocument(item: Register) {
    if (item) {
      if (item.type && item.type.toUpperCase() === 'PF') {
        return item.person?.document
          ? this.maskPipe.transform(
              item.person.document.number,
              '000.000.000-00',
            )
          : '-';
      }

      if (item.type && item.type.toUpperCase() === 'PJ') {
        return item.company?.document
          ? this.maskPipe.transform(
              item.company.document.number,
              '00.000.000/0000-00',
            )
          : '-';
      }
    }
    return '';
  }

  /**
   * Preenche os cards de sumário a partir do objeto `summary` retornado pelo GET my-registers.
   */
  private applySummaryFromMyRegistersResponse(response: any): void {
    const summary = response?.summary;
    if (!summary || typeof summary !== 'object') {
      return;
    }
    this.summaryStatistics = {
      pending:
        summary.em_edicao ?? summary.in_editing ?? 0,
      in_progress:
        summary.em_aprovacao ?? summary.in_approval ?? 0,
      homologated:
        summary.homologados ?? summary.approved ?? 0,
      rejected:
        summary.rejeitados ?? summary.rejected ?? 0,
      active: summary.ativos ?? summary.active ?? 0,
      inactive: summary.inativos ?? summary.inactive ?? 0,
      total: summary.total ?? 0,
    };
  }

  async getData(
    page: number = 1,
    requestId?: number,
    activateSummaryLoading: boolean = false,
  ) {
    // Se não foi passado requestId, usar o contador atual (para compatibilidade com outras chamadas)
    const currentRequestId = requestId || ++this.requestCounter;

    this.accountsLoading = true;
    if (activateSummaryLoading) {
      this.loadingSummary = true;
    }
    try {
      // Carregar os filtros da aba atual (se existirem)
      this.loadTabFilters(this.activeTab);

      // Sempre construir filtros (inclui status da tab)
      const filters = this.buildFilters();

      const params = {
        ...filters,
        page,
        tab: 'all',
        return_distinct: true,
        order_by: this.sortButtonExpanded ? '-created_at' : 'created_at',
      };

      const response: any = await this.api.get<ApiResponse<Register[]>>({
        route: 'api/v3/registration/my-registers/',
        token: true,
        params,
      });

      // Verificar se esta é a última requisição antes de atualizar os dados
      if (currentRequestId !== this.requestCounter) {
        // Esta requisição não é a mais recente, ignorar resultado
        return;
      }

      const { count, results, offset, showing_to } = response;

      this.offset = offset;
      this.showing_to = showing_to || 0;
      this.count = count;
      this.accounts = results;
      this.applySummaryFromMyRegistersResponse(response);
    } catch (error) {
      console.error(error);
      // Se esta não for a última requisição, não fazer nada
      if (currentRequestId !== this.requestCounter) {
        return;
      }
    } finally {
      if (currentRequestId === this.requestCounter) {
        this.accountsLoading = false;
        if (activateSummaryLoading) {
          this.loadingSummary = false;
        }
      }
    }
  }

  renderRoles(item: Register) {
    // Para prestador de serviço, sempre retornar "Prestador de Serviço"
    // ao invés de mostrar os agents
    return 'Prestador de Serviço';
  }

  /**
   * Retorna os papéis formatados do item; nome vem de role_controls[].role.name
   */
  getRolesDisplay(item: Register): string {
    const roleControls = (item as any)?.role_controls;
    if (Array.isArray(roleControls) && roleControls.length > 0) {
      const names = roleControls
        .map((rc: any) => rc?.role?.name)
        .filter(Boolean);
      if (names.length > 0) return names.join(', ');
    }
    if (item.roles && Array.isArray(item.roles) && item.roles.length > 0) {
      let rolesToDisplay = item.roles.filter(
        (role: any) => role && role.applicable_display,
      );
      if (rolesToDisplay.length > 1) {
        rolesToDisplay = rolesToDisplay.filter(
          (role: any) => role.applicable !== 'representative',
        );
      }
      if (rolesToDisplay.length === 0 && item.roles.length > 0) {
        rolesToDisplay = item.roles.filter(
          (role: any) => role && role.applicable_display,
        );
      }
      const roleNames = rolesToDisplay.map(
        (role: any) => role.applicable_display,
      );
      if (roleNames.length > 0) return roleNames.join(', ');
    }
    if (item.role && item.role.applicable_display) {
      return item.role.applicable_display;
    }
    return '-';
  }

  private getRegisterRolesForBadges(register: any): any[] {
    if (!register) return [];
    if (Array.isArray(register?.papers) && register.papers.length > 0) {
      return register.papers
        .map((paper: any) => paper?.role)
        .filter((role: any) => role && (role.applicable_display || role.name));
    }
    return [];
  }

  /**
   * Badges da coluna Papel: somente `papers[].role` (com rótulo Cotista FI).
   */
  getRolesForBadges(
    item: Register,
  ): Array<{ applicable_display?: string; name?: string }> {
    const reg = item as any;
    const rolesFromPapers = this.getRegisterRolesForBadges(reg);
    if (rolesFromPapers.length === 0) {
      return [];
    }

    let rolesToDisplay = rolesFromPapers.filter(
      (role: any) => role && (role.applicable_display || role.name),
    );
    if (rolesToDisplay.length > 1) {
      rolesToDisplay = rolesToDisplay.filter(
        (role: any) => role.applicable !== 'representative',
      );
    }
    if (rolesToDisplay.length === 0) {
      rolesToDisplay = rolesFromPapers;
    }
    return rolesToDisplay.map((role: any) => {
      const roleName = String(role?.name || '').toUpperCase();
      const roleSlug = String(role?.slug || '').toUpperCase();
      const isShareholderFI =
        role?.applicable === 'shareholder' &&
        (roleName.includes('FI') || roleSlug.includes('-FI'));

      if (isShareholderFI) {
        return {
          ...role,
          applicable_display: 'Cotista Fundo de Investimento',
        };
      }
      return role;
    });
  }

  /**
   * Retorna o nome do papel (Pessoa Física, Pessoa Jurídica, etc).
   * Nome vem de role_controls[0].role.name
   */
  getRoleName(item: Register): string {
    const roleControls = (item as any)?.role_controls;
    if (
      Array.isArray(roleControls) &&
      roleControls.length > 0 &&
      roleControls[0]?.role?.name
    ) {
      return roleControls[0].role.name;
    }
    if (item.roles && Array.isArray(item.roles) && item.roles.length > 0) {
      const firstRole = item.roles[0];
      if (firstRole?.name) return firstRole.name;
    }
    if (item.role?.name) return item.role.name;
    return '-';
  }

  getInitials(item: Register) {
    let name = null;

    if (item) {
      if (item.type?.toUpperCase() === 'PF' && item.person) {
        name = item.person.full_name;
      }

      if (item.type?.toUpperCase() === 'PJ' && item.company) {
        name = item.company.corporate_name;
      }
    }

    return name ? Utils.getInitials(name) : '-';
  }

  getName(item: Register) {
    let name = null;

    if (item) {
      if (item.type?.toUpperCase() === 'PF' && item.person) {
        name = item.person.full_name;
      }

      if (item.type?.toUpperCase() === 'PJ' && item.company) {
        name = item.company.corporate_name;
      }
    }

    return name ? name : 'Cadastro em andamento';
  }

  // Verifica se é cotista (shareholder)
  isShareholder(item: Register): boolean {
    // Verificar primeiro no array roles
    if (item.roles && Array.isArray(item.roles) && item.roles.length > 0) {
      return item.roles.some(
        (role: any) => role && role.applicable === 'shareholder',
      );
    }
    // Fallback para role único
    return item?.role?.applicable === 'shareholder';
  }

  // Obter dados do perfil de investidor (mesma lógica do my area dashboard)
  // Prioridade: investor_profile direto > version_data > investor_profile_pf/pj
  getInvestorProfile(item: Register): any {
    if (!item) {
      return null;
    }

    // Prioridade 1: investor_profile direto no register (my-registers)
    if (item.investor_profile) {
      return item.investor_profile;
    }

    // Prioridade 2: Tentar pegar do version_data (registers)
    // Nota: version_data pode ter investor_profile_pf ou investor_profile_pj
    // Mas no contexto de "my-registers", geralmente vem direto em investor_profile

    // Prioridade 3: Tentar pegar do investor_profile_pj (para PJ)
    if (
      item.investor_profile_pj &&
      Array.isArray(item.investor_profile_pj) &&
      item.investor_profile_pj.length > 0
    ) {
      // Pegar o perfil mais recente (maior id)
      return item.investor_profile_pj.reduce((prev, current) => {
        return prev.id > current.id ? prev : current;
      });
    }

    // Prioridade 4: Tentar pegar do investor_profile_pf (para PF)
    if (
      item.investor_profile_pf &&
      Array.isArray(item.investor_profile_pf) &&
      item.investor_profile_pf.length > 0
    ) {
      // Pegar o perfil mais recente (maior id)
      return item.investor_profile_pf.reduce((prev, current) => {
        return prev.id > current.id ? prev : current;
      });
    }

    return null;
  }

  // Obter dados de perfil de investidor/validade do registro (mesma lógica do my area dashboard)
  getInvestorProfileData(item: Register): any {
    if (!this.isShareholder(item)) {
      return null;
    }

    const investorProfile = this.getInvestorProfile(item);

    // Se não tiver investor_profile, retornar null
    if (!investorProfile) {
      return null;
    }

    if (investorProfile.is_exempt === true) {
      return { is_exempt: true };
    }

    // Se not_declared é true ou profile é null, retornar dados para "Não declarado"
    if (
      investorProfile.not_declared === true ||
      investorProfile.profile === null
    ) {
      return {
        not_declared: true,
        profile: null,
      };
    }

    // Se tiver profile (1, 2 ou 3), usar valores da API ou calcular expiração
    // Profile 1 (Conservador): 2 anos
    // Profile 2 (Moderado): 1 ano
    // Profile 3 (Agressivo): 6 meses
    if (
      investorProfile.profile !== null &&
      investorProfile.profile !== undefined
    ) {
      let expireDate: Date | null = null;
      let daysUntilExpiration: number | null = null;
      let expired: boolean = false;

      // Prioridade 1: Usar valores da API se disponíveis
      if (
        investorProfile.days_to_expire !== null &&
        investorProfile.days_to_expire !== undefined
      ) {
        daysUntilExpiration = investorProfile.days_to_expire;
        expired = daysUntilExpiration < 0;

        // Se tiver expire_register, usar como expire_date
        if (investorProfile.expire_register) {
          expireDate = new Date(investorProfile.expire_register);
        }
      }
      // Prioridade 2: Calcular baseado em start_date + duração do perfil
      else if (investorProfile.start_date) {
        const startDate = new Date(investorProfile.start_date);
        expireDate = new Date(startDate);

        // Calcular duração baseada no perfil
        const profile = investorProfile.profile;
        if (profile === 1) {
          // Conservador: 2 anos
          expireDate.setFullYear(expireDate.getFullYear() + 2);
        } else if (profile === 2) {
          // Moderado: 1 ano
          expireDate.setFullYear(expireDate.getFullYear() + 1);
        } else if (profile === 3) {
          // Agressivo: 6 meses
          expireDate.setMonth(expireDate.getMonth() + 6);
        }

        const today = new Date();
        today.setHours(0, 0, 0, 0);
        expireDate.setHours(0, 0, 0, 0);

        const diffTime = expireDate.getTime() - today.getTime();
        daysUntilExpiration = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        expired = daysUntilExpiration < 0;
      }
      // Prioridade 3: Tentar usar validity se disponível
      else if (investorProfile.validity) {
        const expirationDate = new Date(investorProfile.validity);
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        expirationDate.setHours(0, 0, 0, 0);

        const diffTime = expirationDate.getTime() - today.getTime();
        daysUntilExpiration = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        expired = daysUntilExpiration < 0;
        expireDate = expirationDate;
      }

      return {
        profile: investorProfile.profile,
        not_declared: false,
        expire_date: expireDate,
        days_until_expiration: daysUntilExpiration,
        expired: expired,
        start_date: investorProfile.start_date,
        disqualification: investorProfile.disqualification || false,
      };
    }

    return null;
  }

  // Obter configuração do perfil de investidor
  getInvestorProfileConfig(profileNumber: number | null): any {
    const configs: { [key: number]: any } = {
      1: {
        type: 'Conservador',
        badgeTextColor: '#0E6027',
        badgeBackgroundColor: '#A7F0BA',
      },
      2: {
        type: 'Moderado',
        badgeTextColor: '#0043CE',
        badgeBackgroundColor: '#D0E2FF',
      },
      3: {
        type: 'Agressivo',
        badgeTextColor: '#A2191F',
        badgeBackgroundColor: '#FFD7D9',
      },
    };
    return configs[profileNumber || 0] || null;
  }

  // Obter configuração para "Não declarado"
  getNotDeclaredConfig(): any {
    return {
      type: 'Não declarado',
      badgeTextColor: '#4c4c4c',
      badgeBackgroundColor: '#ebebeb',
    };
  }

  /** Cotista isento de perfil de investidor (API: investor_profile.is_exempt) */
  getExemptInvestorProfileConfig(): any {
    return {
      type: 'DISPENSA POR NORMA CONF. ICVM 30, ART. 10 itens II, III ou IV',
      badgeTextColor: '#525252',
      badgeBackgroundColor: '#e0e0e0',
    };
  }

  // Obter estilo do badge de perfil de investidor
  getInvestorProfileBadgeStyle(item: Register): any {
    const data = this.getInvestorProfileData(item);
    if (!data) {
      return {};
    }

    let config;
    if (data.is_exempt === true) {
      config = this.getExemptInvestorProfileConfig();
    } else if (data.not_declared === true || data.profile === null) {
      config = this.getNotDeclaredConfig();
    } else {
      config = this.getInvestorProfileConfig(data.profile);
    }

    if (!config) {
      return {};
    }

    return {
      'background-color': config.badgeBackgroundColor,
      color: config.badgeTextColor,
    };
  }

  // Obter texto do badge de perfil de investidor
  getInvestorProfileBadgeText(item: Register): string {
    const data = this.getInvestorProfileData(item);
    if (!data) {
      return '';
    }

    let config;
    if (data.is_exempt === true) {
      config = this.getExemptInvestorProfileConfig();
    } else if (data.not_declared === true || data.profile === null) {
      config = this.getNotDeclaredConfig();
    } else {
      config = this.getInvestorProfileConfig(data.profile);
    }

    return config ? config.type : '';
  }

  // Verificar se tem perfil de investidor (para exibição)
  hasInvestorProfile(item: Register): boolean {
    if (!item) {
      return false;
    }

    const data = this.getInvestorProfileData(item);
    return data !== null;
  }

  // Verificar se está desenquadrado
  isDisqualified(item: Register): boolean {
    const data = this.getInvestorProfileData(item);
    return data?.disqualification === true;
  }

  // Obter texto de expiração
  getExpirationText(item: Register): string {
    const data = this.getInvestorProfileData(item);
    if (!data) {
      return '';
    }

    if (data.is_exempt === true) {
      return '';
    }

    // Se for "Não declarado", não mostrar texto de expiração
    if (data.not_declared === true || data.profile === null) {
      return '';
    }

    const daysRemaining = data.days_until_expiration ?? 0;
    const expired = data.expired || daysRemaining < 0;

    if (expired) {
      return `Expirado há ${Math.abs(daysRemaining)} dias`;
    }

    return `Expira em ${daysRemaining} dias`;
  }

  // Calcular dias até expiração (para compatibilidade)
  calculateDaysUntilExpiration(item: Register): number {
    const data = this.getInvestorProfileData(item);
    if (!data) {
      return 0;
    }

    return data.days_until_expiration ?? 0;
  }

  // Verificar se está expirado
  isExpired(item: Register): boolean {
    const data = this.getInvestorProfileData(item);
    if (!data) {
      return false;
    }

    return data.expired || (data.days_until_expiration ?? 0) < 0;
  }

  async onTabChange(
    tab: 'all' | 'editing' | 'approval' | 'homologated' | 'rejected',
  ) {
    // Limpar os filtros da aba atual antes de mudar (não salvar)
    this.tabFilters[this.activeTab] = null;

    // Limpar o formulário antes de mudar de aba
    this.filterForm.reset();
    this.filterForm.controls.updated_from?.setValidators([]);
    this.filterForm.controls.updated_to?.setValidators([]);
    this.filterForm.controls.created_from?.setValidators([]);
    this.filterForm.controls.created_to?.setValidators([]);

    this.filterForm.controls.updated_from?.updateValueAndValidity();
    this.filterForm.controls.updated_to?.updateValueAndValidity();
    this.filterForm.controls.created_from?.updateValueAndValidity();
    this.filterForm.controls.created_to?.updateValueAndValidity();

    // Limpar estado de filtros
    this.hasFilters = false;
    this.appliedFilters = [];

    // Ativar ambos os loadings imediatamente
    this.accountsLoading = true;
    this.loadingSummary = true;

    // Incrementar contador de requisições
    this.requestCounter++;
    const currentRequestId = this.requestCounter;

    // Mudar para a nova aba
    this.activeTab = tab;

    // Carregar os filtros da nova aba (se existirem)
    this.loadTabFilters(tab);

    await this.getData(1, currentRequestId, true);
    this.accountsLoading = false;
    this.loadingSummary = false;
  }

  // Carregar os filtros da aba especificada
  loadTabFilters(
    tab: 'all' | 'editing' | 'approval' | 'homologated' | 'rejected',
  ) {
    const savedFilters = this.tabFilters[tab];

    if (savedFilters) {
      // Preparar o documento formatado
      let documentFormatted = null;
      if (savedFilters.document) {
        const docLength = savedFilters.document.length;
        if (docLength === 11) {
          documentFormatted = this.maskPipe.transform(
            savedFilters.document,
            '000.000.000-00',
          );
        } else if (docLength === 14) {
          documentFormatted = this.maskPipe.transform(
            savedFilters.document,
            '00.000.000/0000-00',
          );
        } else {
          // Se não tem tamanho válido, usar o valor original
          documentFormatted = savedFilters.document;
        }
      }

      const { registration_state, role_state, ...rest } = savedFilters;
      const estadoCadastroTodos = !(
        Array.isArray(registration_state) && registration_state.length > 0
      );
      const estadoCadastroAtivo =
        Array.isArray(registration_state) &&
        registration_state.includes('active');
      const estadoCadastroInativo =
        Array.isArray(registration_state) &&
        registration_state.includes('inactive');
      const estadoTodos = !(Array.isArray(role_state) && role_state.length > 0);
      const estadoAtivo =
        Array.isArray(role_state) && role_state.includes('active');
      const estadoInativo =
        Array.isArray(role_state) && role_state.includes('inactive');

      // Restaurar os filtros no formulário
      this.filterForm.patchValue({
        ...rest,
        document: documentFormatted,
        estadoCadastroTodos,
        estadoCadastroAtivo,
        estadoCadastroInativo,
        estadoTodos,
        estadoAtivo,
        estadoInativo,
      });

      // Atualizar estado de filtros
      this.hasFilters = true;
      this.generateFilterTags(this.filterForm.value);
    } else {
      // Se não há filtros salvos, garantir que está limpo
      this.hasFilters = false;
      this.appliedFilters = [];
    }
  }

  getStatusFilterParam(): string | null {
    if (this.activeTab === 'editing') {
      return 'editing';
    } else if (this.activeTab === 'approval') {
      return 'pending';
    } else if (this.activeTab === 'homologated') {
      return 'approved';
    } else if (this.activeTab === 'rejected') {
      return 'rejected';
    }
    // Se for 'all', não adiciona o parâmetro
    return null;
  }

  getStatus(item: Register) {
    // Se tiver current_stage na API v3, usa diretamente
    if (item.current_stage) {
      const currentStage = (item.current_stage || '').toString().trim();

      // Normalizar os valores (PT e EN da API)
      if (
        currentStage === 'Em edição' ||
        currentStage === 'Em edicao' ||
        currentStage.toLowerCase() === 'editing'
      ) {
        return 'Em edição';
      }
      if (
        currentStage === 'Em aprovação' ||
        currentStage === 'Em aprovacao' ||
        currentStage.toLowerCase() === 'in approval'
      ) {
        return 'Em aprovação';
      }
      if (
        currentStage === 'Aprovado' ||
        currentStage === 'Homologado' ||
        currentStage === 'Concluído' ||
        currentStage.toLowerCase() === 'homologated'
      ) {
        return 'Homologado';
      }
      if (
        currentStage === 'Rejeitado' ||
        currentStage.toLowerCase() === 'rejected'
      ) {
        return 'Rejeitado';
      }

      return currentStage;
    }

    // Fallback: se não tiver current_stage, verificar role_controls (qualquer status "editing" = Em edição)
    const roleControls = (item as any)?.role_controls;
    if (Array.isArray(roleControls) && roleControls.length > 0) {
      const hasEditing = roleControls.some(
        (c: any) =>
          (c?.status ?? '').toString().toLowerCase() === 'editing' ||
          (c?.status_display ?? '').toString().toLowerCase() === 'editing',
      );
      if (hasEditing) return 'Em edição';
    }

    // Fallback para lógica antiga se não tiver current_stage
    if (item.approval.length === 0) return 'Em edição';

    if (item.approval[0].completed) {
      if (item.approval[0].is_approved) {
        return 'Homologado';
      } else {
        return 'Rejeitado';
      }
    } else {
      if (item.approval[0].current_department !== undefined) {
        return 'Em aprovação';
      } else if (item.approval[0].step === 0) {
        return 'Em edição';
      } else {
        return 'Em aprovação';
      }
    }
  }

  // Método para obter a classe CSS do badge baseado no status
  getStatusBadgeClass(item: Register): string {
    const status = this.getStatus(item);

    if (status === 'Homologado') {
      return 'status-badge-homologated';
    } else if (status === 'Em aprovação') {
      return 'status-badge-approval';
    } else if (status === 'Em edição') {
      return 'status-badge-editing';
    } else if (status === 'Rejeitado') {
      return 'status-badge-rejected';
    }

    return 'status-badge-editing'; // Default
  }

  // Método para obter o texto do departamento e progresso quando estiver em aprovação ou rejeitado
  getApprovalInfo(item: Register): string {
    const status = this.getStatus(item);

    // Se for rejeitado, mostra o departamento que rejeitou
    if (status === 'Rejeitado') {
      if (item.rejected_department) {
        return item.rejected_department;
      }
      // Fallback: tentar pegar do approval se não tiver rejected_department
      if (item.approval.length > 0 && item.approval[0].current_department) {
        const dept = item.approval[0].current_department;
        return dept.type === 'department'
          ? dept.department?.name || ''
          : dept.agent?.name || '';
      }
      return '';
    }

    // Se for em aprovação, mostra o departamento atual e progresso
    if (status !== 'Em aprovação') {
      return '';
    }

    if (item.approval.length === 0) {
      return '';
    }

    const approval = item.approval[0];

    // Obter o nome do departamento/agente atual
    let departmentName = '';
    if (
      approval.current_department !== undefined &&
      approval.current_department !== null
    ) {
      departmentName =
        approval.current_department.type === 'department'
          ? approval.current_department.department?.name || ''
          : approval.current_department.agent?.name || '';
    }

    // Obter o progresso (step/total)
    const step = approval.step || 0;
    const total =
      approval.queue && approval.queue.departments
        ? approval.queue.departments.length
        : 1;

    if (departmentName && step > 0) {
      return `${departmentName} - ${step}/${total}`;
    } else if (departmentName) {
      return departmentName;
    } else if (step > 0) {
      return `${step}/${total}`;
    }

    return '';
  }

  // Método para obter o label da versão (sempre baseado em approval_version_number)
  getVersionLabel(item: Register): string {
    if (item.approval_version_number != null) {
      return `${item.approval_version_number}ª versão`;
    }
    if (
      item.approval &&
      item.approval.length > 0 &&
      item.approval[0].version_number != null
    ) {
      return `${item.approval[0].version_number}ª versão`;
    }
    return '1ª versão';
  }

  // Método para obter a classe CSS do badge de versão
  getVersionBadgeClass(item: Register): string {
    // Prioridade 1: Usar approval_version_number direto da API
    let versionNumber = item.approval_version_number;

    // Prioridade 2: Tentar pegar do array approval
    if (versionNumber === undefined || versionNumber === null) {
      if (item.approval && item.approval.length > 0) {
        const approval = item.approval[0];
        versionNumber = approval.version_number;
      }
    }

    // Fallback: 1
    versionNumber = versionNumber ?? 1;

    if (versionNumber === 1) {
      return 'version-badge-first';
    } else if (versionNumber >= 2 && versionNumber <= 5) {
      return 'version-badge-middle';
    } else {
      return 'version-badge-high';
    }
  }

  isInApproval(item: Register): boolean {
    if (!item.approval || item.approval.length === 0) {
      return false;
    }

    const approval = item.approval[0];
    // Está em aprovação quando: não está completo, step > 0, e tem departamento definido
    return (
      !approval.completed &&
      approval.step > 0 &&
      approval.current_department !== undefined
    );
  }

  isInEditing(item: Register): boolean {
    const status = this.getStatus(item);
    return status === 'Em edição';
  }

  /**
   * Usado só no botão do olho: trava quando algum role_control está em edição (status "editing").
   */
  isRegisterInEditingForEyeButton(item: Register): boolean {
    const roleControls = (item as any)?.role_controls;
    if (!Array.isArray(roleControls) || roleControls.length === 0) return false;
    return roleControls.some(
      (c: any) =>
        (c?.status ?? '').toString().toLowerCase() === 'editing' ||
        (c?.status_display ?? '').toString().toLowerCase() === 'editing',
    );
  }

  // Método para verificar se pode editar (apenas Homologado ou Em edição)
  canEdit(item: Register): boolean {
    const status = this.getStatus(item);
    return status === 'Homologado' || status === 'Em edição';
  }

  showEditingToast() {
    this.toast.show('info', 'Atenção', 'Cadastro em fase de edição');
  }

  handleEditRoleModal(id: number) {
    this.roleModal = true;
    this.selectedAccount = this.accounts.find(
      (item) => String(item.id) === String(id),
    );

    const newRoleOptions = this.roleOptions.filter((item) => {
      return (
        this.selectedAccount?.agent.findIndex(
          (agent) => agent.id === Number(item.value),
        ) === -1
      );
    });

    this.filteredRoleOptions = newRoleOptions;
  }

  getStatusInfo(item: Register) {
    // Se tiver current_stage e for "Em aprovação", mostra a informação de aprovação
    if (item.current_stage === 'Em aprovação' && item.approval.length > 0) {
      if (item.approval[0].step === 0) {
        return 'Aguardando representantes';
      } else {
        return `Aguardando aprovação (${item.approval[0].step}/${
          item.approval[0].queue && item.approval[0].queue.departments
            ? item.approval[0].queue.departments.length
            : 1
        })`;
      }
    }

    // Para outros casos, mantém a lógica antiga
    if (item.approval.length === 0) return '';

    if (item.approval[0].completed) {
      if (item.approval[0].is_approved) {
        return 'Integração ao fundo';
      } else {
        if (item.approval[0].current_department === undefined) {
          return '';
        }
        if (item.approval[0].current_department !== null) {
          return item.approval[0].current_department.type === 'department'
            ? item.approval[0].current_department.department.name
            : item.approval[0].current_department.agent.name;
        } else if (item.approval[0].step === 0) {
          return 'Edição';
        } else {
          return 'Departamento não definido';
        }
      }
    } else if (item.approval[0].step === 0) {
      return 'Aguardando representantes';
    } else {
      return `Aguardando aprovação (${item.approval[0].step}/${
        item.approval[0].queue && item.approval[0].queue.departments
          ? item.approval[0].queue.departments.length
          : 1
      })`;
    }
  }

  // Método para obter o estágio atual (nome do departamento/Compliance, etc)
  getCurrentStage(item: Register): string {
    if (item.approval.length === 0) return '';

    const approval = item.approval[0];

    // Se estiver em aprovação, retorna o nome do departamento atual
    if (approval.current_department) {
      if (approval.current_department.type === 'department') {
        return approval.current_department.department?.name || '';
      } else {
        return approval.current_department.agent?.name || '';
      }
    }

    return '';
  }

  // Método para formatar data e hora
  displayDateTime(dateStr: string) {
    if (!dateStr) return { date: '-', time: '' };

    const date = dateStr.split('T')[0].split('-');
    const hours = dateStr.split('T')[1]?.split('.')[0].split(':') || [
      '00',
      '00',
    ];

    const day = String(parseInt(date[2])).padStart(2, '0');
    const month = String(parseInt(date[1])).padStart(2, '0');
    const year = date[0];

    return {
      date: `${day}/${month}/${year}`,
      time: `às ${hours[0]}:${hours[1]}`,
    };
  }

  // Método para obter a data de criação formatada
  getCreatedDate(item: Register): string {
    const dateStr = item.created_at || null;
    if (!dateStr) return '-';
    const formatted = this.displayDateTime(dateStr);
    return formatted.date;
  }

  // Método para obter a hora de criação formatada
  getCreatedTime(item: Register): string {
    const dateStr = item.created_at || null;
    if (!dateStr) return '';
    const formatted = this.displayDateTime(dateStr);
    return formatted.time;
  }

  renderLink(item: Register) {
    if (item) {
      // Usar o primeiro role do array se existir, senão usar role único
      let applicable = null;
      if (item.roles && Array.isArray(item.roles) && item.roles.length > 0) {
        applicable = item.roles[0]?.applicable;
      } else if (item.role) {
        applicable = item.role.applicable;
      }

      if (applicable) {
        return [`/app/details/${applicable}/`, item.id];
      }
    }

    return '';
  }

  handleOpenWarningModal(id: number) {
    this.selectedAccount = this.accounts.find(
      (item) => String(item.id) === String(id),
    );

    this.warningModal = true;
  }

  async openEditWarningModal(user: Register) {
    // Se o current_stage for "Aprovado", mostra o modal de aviso
    if (user.current_stage === 'Aprovado') {
      this.selectedAccount = user;
      this.showEditWarningModal = true;
    } else {
      // Se não for "Aprovado", vai direto para a edição
      this.editingLoading = true;
      try {
        await this.redirectToEdit(user);
      } finally {
        this.editingLoading = false;
      }
    }
  }

  closeEditWarningModal() {
    this.showEditWarningModal = false;
    this.selectedAccount = null;
  }

  async confirmEditRedirect() {
    if (this.selectedAccount) {
      this.editingLoading = true;
      try {
        await this.redirectToEdit(this.selectedAccount);
        this.closeEditWarningModal();
      } finally {
        this.editingLoading = false;
      }
    }
  }

  // Helper methods for modal content
  getEditWarningModalTitle() {
    return 'Atenção! Cadastro já aprovado';
  }

  getEditWarningModalMessage() {
    return 'Ao editar e reenviar, o cadastro voltará para aprovação.';
  }

  getEditWarningConfirmText() {
    return 'Sim, editar!';
  }

  getEditWarningCancelText() {
    return 'Cancelar';
  }

  buildFilters(): any {
    const statusParam = this.getStatusFilterParam();
    const values = this.filterForm.value;
    const filters: any = {};

    const checkboxKeys = [
      'profileConservador',
      'profileModerado',
      'profileAgressivo',
      'profileNaoAplicavel',
      'statusHomologado',
      'statusEmAprovacao',
      'statusEmEdicao',
      'statusRejeitado',
      'estadoCadastroTodos',
      'estadoCadastroAtivo',
      'estadoCadastroInativo',
      'estadoTodos',
      'estadoAtivo',
      'estadoInativo',
    ];

    Object.entries(values).forEach(([key, value]: any) => {
      if (
        key === 'updated_from' ||
        key === 'updated_to' ||
        checkboxKeys.includes(key)
      ) {
        return;
      }

      if (value !== null && value !== '' && value !== false) {
        let newValue = value;
        if (key === 'document') {
          newValue = value.replace(/[^\d]/g, '');
        }
        if (
          key === 'created_from' ||
          key === 'created_to' ||
          key === 'expiry_from' ||
          key === 'expiry_to'
        ) {
          newValue = value;
        }
        filters[key] = newValue;
      }
    });

    // Status dos papéis (role_status: pending, editing, homologated, rejected)
    const roleStatuses: string[] = [];
    if (values.statusEmAprovacao) roleStatuses.push('pending');
    if (values.statusEmEdicao) roleStatuses.push('editing');
    if (values.statusHomologado) roleStatuses.push('homologated');
    if (values.statusRejeitado) roleStatuses.push('rejected');
    if (roleStatuses.length) {
      filters['role_status'] = roleStatuses;
    }

    // Perfil de investimento (API: conservative, moderate, aggressive, not_applicable)
    const profiles: string[] = [];
    if (values.profileConservador) profiles.push('conservative');
    if (values.profileModerado) profiles.push('moderate');
    if (values.profileAgressivo) profiles.push('aggressive');
    if (values.profileNaoAplicavel) profiles.push('not_applicable');
    if (profiles.length) {
      filters['investor_profile'] = profiles;
    }

    // Estado do cadastro (seleção única: apenas um por vez)
    if (values.estadoCadastroAtivo) {
      filters['registration_state'] = ['active'];
    } else if (values.estadoCadastroInativo) {
      filters['registration_state'] = ['inactive'];
    }

    // Estado dos papéis (seleção única: apenas um por vez)
    if (values.estadoAtivo) {
      filters['role_state'] = ['active'];
    } else if (values.estadoInativo) {
      filters['role_state'] = ['inactive'];
    }

    if (statusParam) {
      filters['status'] = statusParam;
    }

    return filters;
  }

  async filterData() {
    // Ativar ambos os loadings
    this.accountsLoading = true;
    this.loadingSummary = true;

    try {
      const filters = this.buildFilters();

      const response = await this.api.get<ApiResponse<Register[]>>({
        route: 'api/v3/registration/my-registers/',
        params: {
          page: 1,
          tab: 'all',
          ...filters,
          return_distinct: true,
          order_by: this.sortButtonExpanded ? '-created_at' : 'created_at',
        },
        token: true,
      });

      const { count, results, offset, showing_to } = response;

      // ✅ IMPORTANTE: hasFilters só é atualizado após aplicar os filtros com sucesso
      this.hasFilters = Object.keys(filters).length > 0;

      // Salvar os filtros na aba atual
      if (this.hasFilters) {
        // Remover o parâmetro 'status' dos filtros antes de salvar (ele é específico da aba)
        const filtersToSave = { ...filters };
        delete filtersToSave.status;
        this.tabFilters[this.activeTab] = filtersToSave;
      } else {
        this.tabFilters[this.activeTab] = null;
      }

      // ✅ Gerar as tags dos filtros aplicados
      this.generateFilterTags(this.filterForm.value);

      this.dataFilters = Object.keys(filters).length > 0 ? filters : null;

      this.count = count;
      this.offset = offset;
      this.showing_to = showing_to || 0;

      this.accounts = results;
      this.applySummaryFromMyRegistersResponse(response);
      if (this.sortButtonExpanded) {
        this.accounts.reverse();
      }
    } catch (error) {
      console.error(error);
      this.toast.show(
        'error',
        'Erro',
        'Ocorreu um erro ao carregar os dados de cedente.',
      );
      // Em caso de erro, não atualiza hasFilters
    } finally {
      // Desativar ambos os loadings após ambas as requisições terminarem
      this.accountsLoading = false;
      this.loadingSummary = false;
    }
  }

  async redirectToEdit(user: Register) {
    // PATCH em register-step usando o register.id da URL
    await this.api.patch({
      route: `api/registration/register-step/${user.id}/`,
      body: { substep: 'general', step: 'register' },
      token: true,
    });

    const activeUser = this.authService.getUser();

    this.storageService.setEditUser({
      user: activeUser?.active_register?.id,
      register_id: activeUser?.active_register?.register?.id,
    });

    // Redirecionar incluindo o register.id na rota
    // Usar o primeiro role do array se existir, senão usar role único
    let applicable = null;
    if (user.roles && Array.isArray(user.roles) && user.roles.length > 0) {
      applicable = user.roles[0]?.applicable;
    } else if (user.role) {
      applicable = user.role.applicable;
    }

    if (applicable) {
      this.router.navigate([
        `/signup/${applicable}/${user.type.toLowerCase()}/${user.id}`,
      ]);
    }
  }

  //   async changeActiveRegister(id: number) {
  async changeActiveRegister(id: any) {
    try {
      await this.api.patch({
        route: `user/me/`,
        token: true,
        body: {
          active_register: id,
        },
      });

      const { data } = await this.api.get<ApiResponse<NewLoginResponse>>({
        route: 'user/me/',
        token: true,
      });

      this.authService.setUser(data);
      this.handleRedirect(id);
    } catch (error) {
      console.error(error);
      this.toast.show('error', 'Erro!', 'Erro ao alterar conta ativa');
    }
  }

  handleRedirect(id: number) {
    const account = this.accounts.find(
      (item) => String(item.id) === String(id),
    );

    const isApprover = account.is_approver;
    // Usar o primeiro role do array se existir, senão usar role único
    let applicable = null;
    if (
      account.roles &&
      Array.isArray(account.roles) &&
      account.roles.length > 0
    ) {
      applicable = account.roles[0]?.applicable;
    } else if (account.role) {
      applicable = account.role.applicable;
    }
    const approvals = account.approval;
    const _id = account.id;
    const type = account?.type?.toLowerCase() || '';

    if (applicable === 'representative' || applicable === 'admin') {
      this.router.navigate(['/app/dashboard']);
      return;
    }

    if (approvals.length > 0) {
      if (isApprover) {
        this.router.navigate(['/app/dashboard']);
      } else {
        this.router.navigate([`/app/details/${applicable}/`, _id]);
      }
    } else {
      this.router.navigate([`/signup/${applicable}/${type}`]);
    }
  }

  async resetForm() {
    this.accountsLoading = true;
    this.loadingSummary = true;
    this.appliedFilters = [];

    this.filterForm.reset({
      name: null,
      document: null,
      role: null,
      agent: null,
      created_from: null,
      created_to: null,
      updated_from: null,
      updated_to: null,
      expiry_from: null,
      expiry_to: null,
      profileConservador: false,
      profileModerado: false,
      profileAgressivo: false,
      profileNaoAplicavel: false,
      statusHomologado: false,
      statusEmAprovacao: false,
      statusEmEdicao: false,
      statusRejeitado: false,
      estadoCadastroTodos: true,
      estadoCadastroAtivo: false,
      estadoCadastroInativo: false,
      estadoTodos: true,
      estadoAtivo: false,
      estadoInativo: false,
    });
    this.dataFilters = null;

    // Limpar os filtros da aba atual
    this.tabFilters[this.activeTab] = null;

    // hasFilters deve ser false após limpar
    this.hasFilters = false;

    await this.getData(1, undefined, true);
    this.accountsLoading = false;
    this.loadingSummary = false;
  }

  changePageData(page: number) {
    this.accountsLoading = true;
    this.loadingSummary = true;
    this.getData(page, undefined, true);
  }

  //   formatDate(date: string) {
  //     const day = new Date(date).toLocaleDateString();
  //     const hours = new Date(date).toLocaleTimeString();
  //     return `${day} às ${hours}`;
  //   }

  setPermissions() {
    const permissions = this.authService.mapPermissionsSlugs(
      'my_registers',
      this.permissionObj,
    );

    const isCommonCollaborator = this.authService.isCommonCollaborator();
    const isMaster = this.authService.isMasterUser();

    permissions.forEach((permission, idx) => {
      const key = Object.keys(this.permissionObj)[idx];
      // Permitir canFilter para master e usuários comuns
      if (key === 'canFilter' && (isMaster || isCommonCollaborator)) {
        this.permissionObj[key] = true;
      }
      // Se for colaborador comum, permitir canAdd (novo cadastro)
      else if (key === 'canAdd' && isCommonCollaborator) {
        this.permissionObj[key] = true;
      } else if (key === 'canAdd') {
        // Para canAdd, usar a mesma permissão da tela de todos os registros
        this.permissionObj[key] = this.authService.verifyPermission(
          'de_can_add_registers',
        );
      } else {
        this.permissionObj[key] = this.authService.verifyPermission(permission);
      }
    });
  }

  hasPermission(permission: string, role: string) {
    return this.authService.verifyPermission(`de_can_${permission}_${role}`);
  }

  generateFilterTags(formValues: any) {
    this.appliedFilters = [];

    const fieldLabels: { [key: string]: string } = {
      name: 'Nome / Razão Social',
      document: 'CPF / CNPJ',
      status: 'Estágio Atual',
      role: 'Papel',
      agent: 'Agente',
      created_from: 'Data inicial',
      created_to: 'Data final',
      updated_from: 'Data inicial (atualização)',
      updated_to: 'Data final (atualização)',
    };

    const checkboxKeys = [
      'profileConservador',
      'profileModerado',
      'profileAgressivo',
      'profileNaoAplicavel',
      'statusHomologado',
      'statusEmAprovacao',
      'statusEmEdicao',
      'statusRejeitado',
      'estadoCadastroTodos',
      'estadoCadastroAtivo',
      'estadoCadastroInativo',
      'estadoTodos',
      'estadoAtivo',
      'estadoInativo',
    ];

    Object.entries(formValues).forEach(([key, value]: any) => {
      if (
        key === 'updated_from' ||
        key === 'updated_to' ||
        checkboxKeys.includes(key)
      ) {
        return;
      }

      if (value !== null && value !== '' && value !== undefined) {
        let displayValue = value;

        if (Array.isArray(value) && value.length > 0) {
          if (key === 'agent') {
            displayValue = value
              .map((id: number) => {
                const agent = this.roleOptions.find((a) => a.value === id);
                return agent ? agent.label : id;
              })
              .join(', ');
          } else {
            displayValue = value.join(', ');
          }
        }

        if (key === 'role') {
          const roleOption = this.roleFilterOptions.find(
            (r) => r.value === String(value),
          );
          displayValue = roleOption ? roleOption.label : value;
        }

        if (key === 'status') {
          const statusOption = this.statusOptions.find(
            (s) => s.value === value,
          );
          displayValue = statusOption ? statusOption.label : value;
        }

        if (key === 'created_from' || key === 'created_to') {
          if (value) {
            const date = new Date(value);
            displayValue = date.toLocaleDateString('pt-BR');
          }
        } else if (key === 'updated_from' || key === 'updated_to') {
          displayValue = value;
        } else if (key === 'expiry_from' || key === 'expiry_to') {
          if (value) {
            const date = new Date(value);
            displayValue = date.toLocaleDateString('pt-BR');
          }
        }

        if (fieldLabels[key]) {
          this.appliedFilters.push({
            label: `${fieldLabels[key]}: ${String(displayValue)}`,
            value: String(displayValue),
          });
        } else if (key === 'expiry_from') {
          this.appliedFilters.push({
            label: `Data vencimento (de): ${String(displayValue)}`,
            value: String(displayValue),
          });
        } else if (key === 'expiry_to') {
          this.appliedFilters.push({
            label: `Data vencimento (até): ${String(displayValue)}`,
            value: String(displayValue),
          });
        }
      }
    });

    // Tags para checkboxes (um tag por grupo)
    const profileLabels: string[] = [];
    if (formValues.profileConservador) profileLabels.push('Conservador');
    if (formValues.profileModerado) profileLabels.push('Moderado');
    if (formValues.profileAgressivo) profileLabels.push('Agressivo');
    if (formValues.profileNaoAplicavel) profileLabels.push('Não aplicável');
    if (profileLabels.length) {
      this.appliedFilters.push({
        label: `Perfil de investimento: ${profileLabels.join(', ')}`,
        value: profileLabels.join(', '),
      });
    }

    const statusLabels: string[] = [];
    if (formValues.statusEmAprovacao) statusLabels.push('Em aprovação');
    if (formValues.statusEmEdicao) statusLabels.push('Em edição');
    if (formValues.statusHomologado) statusLabels.push('Homologado');
    if (formValues.statusRejeitado) statusLabels.push('Rejeitado');
    if (statusLabels.length) {
      this.appliedFilters.push({
        label: `Status dos papéis: ${statusLabels.join(', ')}`,
        value: statusLabels.join(', '),
      });
    }

    if (formValues.estadoCadastroAtivo) {
      this.appliedFilters.push({
        label: 'Estado do cadastro: Ativo',
        value: 'Ativo',
      });
    } else if (formValues.estadoCadastroInativo) {
      this.appliedFilters.push({
        label: 'Estado do cadastro: Inativo',
        value: 'Inativo',
      });
    }

    if (formValues.estadoAtivo) {
      this.appliedFilters.push({
        label: 'Estado dos papéis: Ativo',
        value: 'Ativo',
      });
    } else if (formValues.estadoInativo) {
      this.appliedFilters.push({
        label: 'Estado dos papéis: Inativo',
        value: 'Inativo',
      });
    }
  }

  getCurrentPapersText(): string {
    if (!this.currentPapers || this.currentPapers.length === 0) {
      return '';
    }
    return this.currentPapers.map((p) => p.description).join(', ');
  }

  getCurrentRolesText(): string {
    if (!this.currentRole || this.currentRole.length === 0) {
      return '';
    }
    return this.currentRole
      .map((r) => r.applicable_display || r.name)
      .join(' - ');
  }

  getRolesArray(): string[] {
    if (this.currentRole && this.currentRole.length > 0) {
      return this.currentRole.map((r) => r.applicable_display || r.name);
    }
    if (this.currentPapers && this.currentPapers.length > 0) {
      return this.currentPapers.map((p) => p.description);
    }
    return [];
  }

  getRolesMessage(): string {
    const rolesArray = this.getRolesArray();

    if (rolesArray.length === 0) {
      return 'Esta pessoa já possui cadastro no sistema.';
    }

    const isPlural = rolesArray.length > 1;
    return `Esta pessoa já possui cadastro no sistema com o ${
      isPlural ? 'papéis' : 'papel'
    }:`;
  }

  getDocumentType(): string {
    const documentValue = this.newUserForm.controls.document.value;
    if (!documentValue) {
      return 'CPF / CNPJ';
    }
    const cleanDocument = Utils.onlyNumbers(documentValue);
    return cleanDocument.length === 11 ? 'CPF' : 'CNPJ';
  }

  getApprovedRolesText(): string {
    if (!this.approvedRoles || this.approvedRoles.length === 0) {
      return '';
    }
    const roleLabels = this.approvedRoles.map((role: any) => {
      const typeMap: { [key: string]: string } = {
        assignor: 'cedente',
        shareholder: 'cotista',
        provider: 'prestador de serviço',
      };
      return (
        typeMap[role.applicable] || role.applicable_display || role.applicable
      );
    });

    if (roleLabels.length === 1) {
      return roleLabels[0];
    } else if (roleLabels.length === 2) {
      return roleLabels.join(' e ');
    } else {
      const last = roleLabels.pop();
      return roleLabels.join(', ') + ' e ' + last;
    }
  }

  getCollaboratorCompanies(): string {
    if (
      !this.collaboratorInfo ||
      !this.collaboratorInfo.companies ||
      this.collaboratorInfo.companies.length === 0
    ) {
      return '';
    }
    return this.collaboratorInfo.companies
      .map((c) => c.brand_name || c.corporate_name)
      .join(', ');
  }

  getCollaboratorDepartments(): string {
    if (
      !this.collaboratorInfo ||
      !this.collaboratorInfo.departments ||
      this.collaboratorInfo.departments.length === 0
    ) {
      return '';
    }
    return this.collaboratorInfo.departments.map((d) => d.name).join(', ');
  }

  getCollaboratorType(): string {
    if (!this.collaboratorInfo || !this.collaboratorInfo.collaborator_type) {
      return '';
    }
    const types = {
      master: 'Master',
      manager: 'Gerente',
      operator: 'Operador',
      viewer: 'Visualizador',
    };
    return (
      types[this.collaboratorInfo.collaborator_type] ||
      this.collaboratorInfo.collaborator_type
    );
  }

  getCollaboratorDocument(): string {
    if (!this.collaboratorInfo || !this.collaboratorInfo.document) {
      return '';
    }
    const doc = this.collaboratorInfo.document;
    // Formatar CPF (11 dígitos) ou CNPJ (14 dígitos)
    if (doc.length === 11) {
      return doc.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    } else if (doc.length === 14) {
      return doc.replace(
        /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
        '$1.$2.$3/$4-$5',
      );
    }
    return doc;
  }

  toggleNewUserModal() {
    this.selectedApplicable = null;
    this.selectedNewUserApplicable = null;
    if (this.newUserModal) {
      this.newUserForm.reset();
      this.isCnpjDocument = false;
      // Resetar variáveis de validação de documento
      this.checkingDocument = false;
      this.documentExists = null;
      this.availablePapers = [];
      this.currentPapers = [];
      this.currentRole = [];
      this.userName = '';
      this.isCollaborator = false;
      this.collaboratorInfo = null;
      this.collaboratorMessage = '';
      this.hasPendingApproval = false;
      this.pendingApprovalRole = '';
      this.hasInviteSent = false;
      this.inviteStatus = '';
      this.invitedData = null;
      this.hasRoleDraft = false;
      this.roleDraftInfo = null;
      this.approvedRoles = [];
      this.documentVerified = false;
      this.showOtherFields = false;
      this.documentInviteError = null;
      this.existingRegisterId = null;
      // Resetar opções de papéis para mostrar todos
      this.updatePrimaryRoleOptions();
    }

    this.newUserModal = !this.newUserModal;
  }

  async getFunds() {
    this.loadingFunds = true;
    try {
      const res = await this.api.get({
        route: 'api/v2/approvals/funds-dropdown/active/',
        token: true,
      });

      // A API já retorna no formato correto com label e value
      this.fundOptions = res.data || [];
    } catch (error) {
      this.toast.show('error', 'Erro!', 'Erro ao carregar fundos de interesse');
    } finally {
      this.loadingFunds = false;
    }
  }

  async verifyDocument() {
    const documentValue = this.newUserForm.controls.document.value;
    if (!documentValue) {
      return;
    }

    const documentClean = documentValue
      ? documentValue.replace(/[^\d]+/g, '')
      : '';

    // Resetar estado ao mudar documento
    this.documentExists = null;
    this.availablePapers = [];
    this.currentPapers = [];
    this.userName = '';
    this.isCollaborator = false;
    this.collaboratorInfo = null;
    this.collaboratorMessage = '';
    this.hasPendingApproval = false;
    this.pendingApprovalRole = '';
    this.hasInviteSent = false;
    this.inviteStatus = '';
    this.invitedData = null;
    this.hasRoleDraft = false;
    this.roleDraftInfo = null;
    this.approvedRoles = [];
    this.existingRegisterId = null;

    // Limpar erros anteriores
    this.newUserForm.controls.document.setErrors(null);

    // Verificar se o documento tem tamanho válido (CPF 11 dígitos ou CNPJ 14 dígitos)
    const isValidLength =
      documentClean.length === 11 || documentClean.length === 14;

    if (!isValidLength) {
      // Se não tem tamanho válido mas tem algum valor, limpar erros
      if (documentClean.length > 0 && documentClean.length < 11) {
        this.newUserForm.controls.document.setErrors(null);
      }
      return;
    }

    // Validar CPF ou CNPJ antes de chamar a API
    let isValid = false;
    let errorKey = '';
    if (documentClean.length === 11) {
      isValid = BrValidators.cpf(documentClean);
      errorKey = 'cpf';
    } else if (documentClean.length === 14) {
      isValid = BrValidators.cnpj(documentClean);
      errorKey = 'cnpj';
    }

    if (!isValid) {
      // Marcar campo como inválido
      this.newUserForm.controls.document.setErrors({ [errorKey]: true });
      this.newUserForm.controls.document.markAsTouched();
      return;
    }

    // Limpar erros antes de chamar API (documento válido)
    this.newUserForm.controls.document.setErrors(null);

    this.checkingDocument = true;

    try {
      const res = await this.api.post({
        route: 'validate-user-paper-exists/',
        body: { document: documentClean },
        token: true,
      });

      this.checkingDocument = false;

      // Verificar se há papéis com status diferente de "Aprovado"
      // current_role pode estar no nível raiz ou dentro de res.data
      this.hasPendingApproval = false;
      this.pendingApprovalRole = '';
      this.approvedRoles = [];

      const currentRoleRaw =
        res.current_role || (res.data && res.data.current_role);

      // Considerar todos os papéis (incluindo representante) para exibição e "tem cadastro"
      const hasValidRoles =
        currentRoleRaw &&
        Array.isArray(currentRoleRaw) &&
        currentRoleRaw.length > 0;

      if (hasValidRoles) {
        // Para travar por "em aprovação": só papéis que NÃO são representante (representante sempre homologado para efeito de bloqueio)
        const rolesForBlocking = currentRoleRaw.filter(
          (role: any) => role.applicable !== 'representative',
        );
        const pendingRole = rolesForBlocking.find(
          (role: any) => role.status && role.status !== 'Aprovado',
        );

        if (pendingRole) {
          this.hasPendingApproval = true;
          this.pendingApprovalRole = pendingRole.applicable_display || '';
        }

        // Badges e "pode adicionar papel": aprovados + representante (rep sempre conta como ok para liberar e PATCH)
        this.approvedRoles = currentRoleRaw.filter(
          (role: any) =>
            role.status === 'Aprovado' || role.applicable === 'representative',
        );
      }

      // Verificar se há convite já enviado com status sent ou viewed
      // Se for used, não bloqueia (permite outras verificações)
      this.hasInviteSent = false;
      this.inviteStatus = '';
      this.invitedData = null;

      const invited = res.invited || (res.data && res.data.invited);
      if (invited && invited.status) {
        const inviteStatus = invited.status;
        if (inviteStatus === 'sent' || inviteStatus === 'viewed') {
          this.hasInviteSent = true;
          this.inviteStatus = inviteStatus;
          this.invitedData = invited; // Armazenar dados completos do convite
        }
      }

      // Verificar se há role_draft (adição de papel em andamento)
      // Se role_draft existir (não for null/undefined), significa que há adição de papel em andamento
      // role_draft pode estar no nível raiz ou dentro de res.data
      const roleDraft = res.role_draft || (res.data && res.data.role_draft);

      this.hasRoleDraft = false;
      this.roleDraftInfo = null;

      if (roleDraft !== null && roleDraft !== undefined) {
        // Sempre travar quando houver role_draft, independentemente de estar aprovado
        // Se há role_draft, significa que há uma adição de papel em andamento
        this.hasRoleDraft = true;
        this.roleDraftInfo = roleDraft;
        // Quando há role_draft, bloquear o cadastro
        this.documentExists = true;
        // Definir userName se disponível
        if (res.name || (res.data && res.data.name)) {
          this.userName = res.name || res.data.name;
        }
      }

      // Verificar se é um colaborador
      if (res.is_collaborator && res.collaborator) {
        this.isCollaborator = true;
        this.collaboratorInfo = res.collaborator;
        this.collaboratorMessage = res.message || '';
        this.documentExists = true; // Bloquear cadastro

        // Se houver aprovação pendente, também definir userName se disponível
        if (res.data && res.data.name) {
          this.userName = res.data.name;
        } else if (res.name) {
          // Capturar nome diretamente de res.name se disponível
          this.userName = res.name;
        }
      } else {
        this.isCollaborator = false;
        this.collaboratorInfo = null;
        this.collaboratorMessage = '';
        this.documentExists = hasValidRoles && res.exists === true;

        if (this.documentExists && res.data) {
          this.userName = res.data.name || res.name || '';
          this.availablePapers = res.data.papers || [];
          this.currentPapers = res.data.current_papers || [];
          this.currentRole = res.data.current_role || [];
          // Armazenar register_id se disponível (paper exists já pode devolver o uuid em data.id)
          this.existingRegisterId =
            res.data.register_id ||
            res.data.id ||
            res.register_id ||
            res.id ||
            null;
        } else if (this.documentExists && res.name) {
          this.userName = res.name;
        } else if (res.name && this.approvedRoles.length > 0) {
          // Se não documentExists mas tem papéis aprovados, definir userName
          this.userName = res.name;
        } else if (res.name) {
          // Se houver nome na resposta, definir userName mesmo sem documentExists
          this.userName = res.name;
        }
      }

      // Se houver aprovação pendente, convite já enviado ou role_draft, bloquear cadastro
      if (this.hasPendingApproval || this.hasInviteSent || this.hasRoleDraft) {
        this.documentExists = true;
        // Se houver convite enviado mas não houver userName, tentar pegar da mensagem ou definir como vazio
        if (this.hasInviteSent && !this.userName && res.message) {
          // A mensagem pode conter informações úteis, mas não vamos definir userName aqui
        }
        // Se houver role_draft mas não houver userName, pegar do res.name
        if (this.hasRoleDraft && !this.userName && res.name) {
          this.userName = res.name;
        }
      }

      // Se passou em todas as validações (não é colaborador, não tem aprovação pendente, não tem convite enviado, não tem role_draft)
      // e o documento foi verificado, mostrar os campos para preenchimento
      // Isso acontece quando exists = false OU quando exists = true e tem papéis que permitem adicionar outro (aprovados ou representante)
      if (
        !this.checkingDocument &&
        !this.isCollaborator &&
        !this.hasPendingApproval &&
        !this.hasInviteSent &&
        !this.hasRoleDraft
      ) {
        if (
          res.exists === false ||
          (res.exists === true && this.approvedRoles.length > 0) ||
          (res.exists === true && !hasValidRoles)
        ) {
          this.documentVerified = true;
          this.showOtherFields = true;

          // Atualizar opções de papéis filtradas por tipo de documento e papéis já aprovados
          this.updatePrimaryRoleOptions(documentClean);

          // Armazenar register_id se disponível (paper exists já devolve o uuid em data.id ou data.register_id)
          if (res.exists === true && this.approvedRoles.length > 0) {
            this.existingRegisterId =
              res.data?.register_id ||
              res.data?.id ||
              res.register_id ||
              res.id ||
              null;

            // Se não tiver register_id na resposta, buscar pelo documento
            if (!this.existingRegisterId && documentClean) {
              try {
                const registerResponse = await this.api.get<any>({
                  route: `api/v3/registration/registers/`,
                  params: {
                    document: documentClean,
                    type: 'register',
                  },
                  token: true,
                });

                // Pegar o primeiro resultado (deve haver apenas um register por documento)
                if (
                  registerResponse?.results &&
                  registerResponse.results.length > 0
                ) {
                  const first = registerResponse.results[0];
                  this.existingRegisterId =
                    (first?.id ?? first?.register?.id)?.toString() ?? null;
                }
              } catch (error) {
                console.error('Erro ao buscar register pelo documento:', error);
                // Continuar sem register_id, o fluxo normal de criação será usado
              }
            }
          }

          // Preencher o campo full_name se houver nome disponível
          if (this.userName) {
            this.newUserForm.controls.full_name.setValue(this.userName);
          }

          // Preencher o campo email se houver email disponível na resposta
          const email = res.email || (res.data && res.data.email);
          if (email) {
            this.newUserForm.controls.email.setValue(email);
          }
        }
      }
    } catch (error) {
      console.error('Erro ao validar documento:', error);
      this.checkingDocument = false;
      this.documentExists = null;
      this.isCollaborator = false;
      this.collaboratorInfo = null;
      this.collaboratorMessage = '';
      this.hasPendingApproval = false;
      this.pendingApprovalRole = '';
      this.hasInviteSent = false;
      this.inviteStatus = '';
      this.invitedData = null;
      this.hasRoleDraft = false;
      this.roleDraftInfo = null;
      this.approvedRoles = [];
      this.existingRegisterId = null;
    }
  }

  async registerNewUser() {
    // Marcar todos os campos como touched para mostrar erros de validação
    this.newUserForm.markAllAsTouched();

    // Se o formulário for inválido, não prosseguir
    if (this.newUserForm.invalid) {
      return;
    }

    const ids = {
      user: this.authService.user.active_register.id,
      register_id: this.authService.user.active_register.register.id,
    };
    this.storageService.setEditUser(ids);

    this.sendingRequest = true;

    try {
      const selectedRole = this.roles.find(
        (item) => item.id === Number(this.newUserForm.value.role),
      );

      const type = selectedRole.slug.split('-')[1]?.toUpperCase();
      const applicable = selectedRole.applicable;

      // Limpar o documento (remover formatação)
      const documentClean = this.newUserForm.value.document
        ? this.newUserForm.value.document.replace(/[^\d]+/g, '')
        : '';

      // Verificar se estamos adicionando papel a um usuário existente
      if (this.existingRegisterId && this.approvedRoles.length > 0) {
        // Fluxo: Adicionar papel a usuário existente
        // 1. Fazer PATCH para adicionar role_draft

        try {
          await this.api.patch({
            route: `api/v3/registration/registers/`,
            body: {
              register_uuid: this.existingRegisterId,
              role_draft: selectedRole.id,
            },
            token: true,
          });

          // 2. PATCH no register-step para definir o trace step
          await this.api.patch({
            route: `api/registration/register-step/${this.existingRegisterId}/`,
            body: { substep: 'general', step: 'register' },
            token: true,
          });

          // 3. Determinar o type baseado no documento (CPF = PF, CNPJ = PJ)
          const registerType = documentClean.length === 11 ? 'pf' : 'pj';

          // 4. Redirecionar para a página de cadastro
          this.newUserForm.reset();
          this.newUserModal = false;
          this.sendingRequest = false;

          this.router.navigate([
            `/signup/${applicable}/${registerType}/${this.existingRegisterId}`,
          ]);

          return;
        } catch (error) {
          console.error('Erro ao adicionar role_draft:', error);
          this.toast.show(
            'error',
            'Erro!',
            'Erro ao adicionar papel ao usuário existente',
          );
          this.sendingRequest = false;
          return;
        }
      }

      // Fluxo normal: Criar novo cadastro
      const payload: any = {
        role: selectedRole.id,
        type,
        status: 'created',
      };

      // Adicionar email se existir
      if (this.newUserForm.value.email) {
        payload.email = this.newUserForm.value.email;
      }

      // Adicionar interest_fund apenas se existir
      if (this.newUserForm.value.interest_fund) {
        payload.interest_fund = this.newUserForm.value.interest_fund;
      }

      // Se for PJ, usar company; se for PF, usar person
      if (type === 'PJ') {
        payload.company = {
          corporate_name: this.newUserForm.value.full_name || '',
          document: {
            number: documentClean,
          },
        };
      } else {
        payload.name = this.newUserForm.value.full_name || '';
        payload.person = {
          full_name: this.newUserForm.value.full_name || '',
          document: {
            number: documentClean,
          },
        };
      }

      if (this.newUserForm.value.agent) {
        payload['agent'] = this.newUserForm.value.agent;
      }

      const res = await this.api.post({
        route: 'api/registration/register/',
        token: true,
        body: payload,
      });

      this.storageService.setNewUserData({
        ...payload,
        document: this.newUserForm.value.document,
        role: this.newUserForm.value.agent,
      });

      this.newUserForm.reset();
      this.newUserModal = false;

      this.sendingRequest = false;

      // Redirecionamento direto com os dados que já temos
      const registerId = res.data.id;
      // Usar o type da resposta da API ao invés do extraído do slug, pois pode estar mais correto
      const typeFromResponse = res.data.type
        ? res.data.type.toLowerCase()
        : type.toLowerCase();
      const typeLower = typeFromResponse;

      this.router.navigate([
        `/signup/${applicable}/${typeLower}/${registerId}`,
      ]);
    } catch (error) {
      this.toast.show('error', 'Erro!', 'Erro ao cadastrar usuário');
      this.sendingRequest = false;
    }
  }
}
